{
  "common": {
    "from": "от {{price}}",
    "soon": "скоро",
    "online": "Онлайн",
    "back": "Назад",
    "close": "Закрыть",
    "cancel": "Отмена",
    "apply": "Применить",
    "retry": "Повторить",
    "retryLater": "Попробуй ещё раз чуть позже.",
    "loading": "Загрузка…",
    "increase": "Больше",
    "decrease": "Меньше"
  },
  "categories": {
    "HOME": {
      "name": "Быт",
      "short": "Клининг, ремонт, трансфер"
    },
    "DOCS": {
      "name": "Документы",
      "short": "Соцкарта, перевод, ВНЖ"
    },
    "LEARNING": {
      "name": "Обучение и карьера",
      "short": "Языки и карьерный консультант"
    },
    "PERKS": {
      "name": "Скидки и подарки",
      "short": "Кофейни, рестораны, подарки"
    }
  },
  "services": {
    "cleaning": {
      "name": "Клининг",
      "description": "Обычная, генеральная или после ремонта. Проверенные клинеры, фотоотчёт после уборки."
    },
    "repair": {
      "name": "Ремонт",
      "description": "Сантехника, электрика и мелкий ремонт. Мастер согласует смету до начала работ."
    },
    "transfer": {
      "name": "Трансфер",
      "description": "Встретим в аэропорту или отвезём на рейс."
    },
    "social_card": {
      "name": "Соцкарта",
      "description": "Поможем оформить социальную карту."
    },
    "passport_translation": {
      "name": "Перевод паспорта",
      "description": "Нотариальный перевод паспорта."
    },
    "residence_permit": {
      "name": "ВНЖ",
      "description": "Сопровождение до готового вида на жительство."
    },
    "lang_armenian": {
      "name": "Армянский",
      "description": "Пакет уроков армянского онлайн или офлайн."
    },
    "lang_english": {
      "name": "Английский",
      "description": "Пакет уроков английского онлайн или офлайн."
    },
    "career": {
      "name": "Карьерный консультант",
      "description": "Разбор резюме и план поиска работы."
    }
  },
  "params": {
    "cleaning": {
      "cleaningType": {
        "label": "Тип уборки",
        "regular": "Обычная",
        "regular_hint": "Поддерживающая уборка",
        "general": "Генеральная",
        "general_hint": "Всё, включая труднодоступные места",
        "renovation": "После ремонта",
        "renovation_hint": "Пыль, следы краски и цемента"
      },
      "rooms": {
        "label": "Комнат",
        "count_one": "{{count}} комната",
        "count_few": "{{count}} комнаты",
        "count_many": "{{count}} комнат",
        "count_other": "{{count}} комнаты"
      },
      "bathrooms": {
        "label": "Санузлов",
        "count_one": "{{count}} санузел",
        "count_few": "{{count}} санузла",
        "count_many": "{{count}} санузлов",
        "count_other": "{{count}} санузла"
      }
    },
    "repair": {
      "repairType": {
        "label": "Что случилось",
        "plumbing": "Сантехника",
        "plumbing_hint": "Краны, трубы, унитаз",
        "electrical": "Электрика",
        "electrical_hint": "Розетки, свет, проводка",
        "minor": "Мелкий ремонт",
        "minor_hint": "Полки, двери, мебель"
      },
      "problem": {
        "label": "Опиши проблему"
      }
    },
    "transfer": {
      "direction": {
        "label": "Направление",
        "fromAirport": "Из аэропорта",
        "fromAirport_hint": "Встретим с табличкой",
        "toAirport": "В аэропорт",
        "toAirport_hint": "Отвезём к рейсу"
      },
      "flight": {
        "label": "Номер рейса"
      },
      "passengers": {
        "label": "Пассажиров"
      },
      "luggage": {
        "label": "Мест багажа"
      }
    },
    "social_card": {
      "forWhom": {
        "label": "Для кого",
        "self": "Для меня",
        "self_hint": "Один человек",
        "family": "Для семьи",
        "family_hint": "Несколько человек"
      }
    },
    "passport_translation": {
      "forWhom": {
        "label": "Для кого",
        "self": "Для меня",
        "self_hint": "Один паспорт",
        "family": "Для семьи",
        "family_hint": "Несколько паспортов"
      }
    },
    "residence_permit": {
      "forWhom": {
        "label": "Для кого",
        "self": "Для меня",
        "self_hint": "Один человек",
        "family": "Для семьи",
        "family_hint": "Несколько человек"
      }
    },
    "lang_armenian": {
      "level": {
        "label": "Уровень",
        "A1": "A1",
        "A1_hint": "С нуля",
        "A2": "A2",
        "A2_hint": "Базовый",
        "B1": "B1",
        "B1_hint": "Средний",
        "B2": "B2",
        "B2_hint": "Выше среднего"
      },
      "format": {
        "label": "Формат",
        "online": "Онлайн",
        "online_hint": "По видеосвязи",
        "offline": "Офлайн",
        "offline_hint": "В Ереване"
      },
      "lessons": {
        "label": "Пакет",
        "4": "4 урока",
        "4_hint": "Попробовать",
        "8": "8 уроков",
        "8_hint": "Месяц",
        "12": "12 уроков",
        "12_hint": "Интенсив"
      }
    },
    "lang_english": {
      "level": {
        "label": "Уровень",
        "A1": "A1",
        "A1_hint": "С нуля",
        "A2": "A2",
        "A2_hint": "Базовый",
        "B1": "B1",
        "B1_hint": "Средний",
        "B2": "B2",
        "B2_hint": "Выше среднего",
        "C1": "C1",
        "C1_hint": "Продвинутый"
      },
      "format": {
        "label": "Формат",
        "online": "Онлайн",
        "online_hint": "По видеосвязи",
        "offline": "Офлайн",
        "offline_hint": "В Ереване"
      },
      "lessons": {
        "label": "Пакет",
        "4": "4 урока",
        "4_hint": "Попробовать",
        "8": "8 уроков",
        "8_hint": "Месяц",
        "12": "12 уроков",
        "12_hint": "Интенсив"
      }
    },
    "career": {
      "topic": {
        "label": "Тема",
        "resume": "Разбор резюме",
        "resume_hint": "Что улучшить",
        "jobSearch": "План поиска работы",
        "jobSearch_hint": "Куда и как откликаться"
      }
    }
  },
  "extras": {
    "windows": {
      "name": "Мытьё окон",
      "per": "за окно"
    },
    "balconyGlazing": {
      "name": "Остекление балкона",
      "per": "за балкон"
    },
    "balcony": {
      "name": "Уборка балкона",
      "per": "за балкон"
    },
    "fridge": {
      "name": "Холодильник внутри"
    },
    "oven": {
      "name": "Духовка внутри"
    },
    "microwave": {
      "name": "Микроволновка внутри"
    },
    "kitchenCabinets": {
      "name": "Кухонные шкафы внутри"
    },
    "complexKitchen": {
      "name": "Сильно загрязнённая кухня"
    },
    "chandelier": {
      "name": "Люстра",
      "per": "за шт."
    },
    "wardrobe": {
      "name": "Гардеробная"
    },
    "limescale": {
      "name": "Налёт и ржавчина в санузле"
    },
    "petHair": {
      "name": "Удаление шерсти питомцев"
    },
    "litter": {
      "name": "Лоток питомца",
      "per": "за шт."
    },
    "ironing": {
      "name": "Глажка",
      "per": "за час"
    },
    "extraTime": {
      "name": "Дополнительное время",
      "per": "за 30 мин"
    },
    "keys": {
      "name": "Забрать и вернуть ключи"
    },
    "experienced": {
      "name": "Опытный клинер"
    },
    "vacuum": {
      "name": "Привезти пылесос"
    }
  },
  "checklist": {
    "kitchen": "Кухня",
    "bathroom": "Санузел",
    "rooms": "Комнаты",
    "floors": "Полы",
    "photoReport": "Фотоотчёт",
    "diagnostics": "Диагностика",
    "estimate": "Смета",
    "repair": "Ремонт",
    "photo": "Фото",
    "luggage": "Багаж",
    "address": "Адрес",
    "review": "Повторение",
    "newTopic": "Новая тема",
    "homework": "Домашнее задание",
    "resume": "Резюме",
    "plan": "План",
    "materials": "Материалы"
  },
  "status": {
    "CLEANING": {
      "NEW": "Новый",
      "ASSIGNED": "Назначен",
      "EN_ROUTE": "В пути",
      "CLEANING": "Уборка",
      "DONE": "Готово",
      "CANCELLED": "Отменён"
    },
    "REPAIR": {
      "NEW": "Новый",
      "ASSIGNED": "Назначен",
      "ON_SITE": "На месте",
      "ESTIMATE_APPROVED": "Смета согласована",
      "REPAIRING": "Ремонт",
      "DONE": "Готово",
      "CANCELLED": "Отменён"
    },
    "TRANSFER": {
      "NEW": "Новый",
      "ASSIGNED": "Назначен",
      "DRIVER_WAITING": "Водитель ждёт",
      "RIDE_IN_PROGRESS": "В пути",
      "COMPLETED": "Завершён",
      "CANCELLED": "Отменён"
    },
    "LANGUAGE": {
      "ENROLLED": "Записан",
      "LESSON_SCHEDULED": "Урок запланирован",
      "LESSON_IN_PROGRESS": "Идёт урок",
      "LESSON_DONE": "Урок завершён",
      "COMPLETED": "Пакет пройден",
      "CANCELLED": "Отменён"
    },
    "CAREER": {
      "NEW": "Новый",
      "CONSULTANT_ASSIGNED": "Консультант назначен",
      "RESUME_RECEIVED": "Резюме получено",
      "MEETING": "Встреча",
      "PLAN_SENT": "План отправлен",
      "CANCELLED": "Отменён"
    },
    "DOCUMENTS": {
      "NEW": "Новый",
      "DOCS_REVIEW": "Документы проверяются",
      "NEEDS_MORE_DOCS": "Нужны доп. документы",
      "SUBMITTED": "Подача",
      "DONE": "Готово",
      "CANCELLED": "Отменён"
    }
  },
  "payment": {
    "UNPAID": "Не оплачен",
    "PAID": "Оплачен",
    "REFUNDED": "Возврат"
  },
  "roles": {
    "CLEANER": "Клинер",
    "HANDYMAN": "Мастер",
    "DRIVER": "Водитель",
    "TEACHER": "Преподаватель",
    "CAREER_CONSULTANT": "Карьерный консультант",
    "DOCS_AGENT": "Специалист по документам"
  },
  "districts": {
    "ajapnyak": "Аджапняк",
    "arabkir": "Арабкир",
    "avan": "Аван",
    "davtashen": "Давташен",
    "erebuni": "Эребуни",
    "kanaker_zeytun": "Канакер-Зейтун",
    "kentron": "Кентрон",
    "malatia_sebastia": "Малатия-Себастия",
    "nork_marash": "Норк-Мараш",
    "nor_nork": "Нор-Норк",
    "nubarashen": "Нубарашен",
    "shengavit": "Шенгавит"
  },
  "plans": {
    "free": {
      "perks": "Скидки и подарки партнёров",
      "prices": "Все услуги по обычной цене",
      "status": "Статусы заявок и чат"
    },
    "plus": {
      "price": "{{price}}/мес",
      "all": "Всё из Barev",
      "discount": "−{{pct}}% на направление «{{category}}»"
    }
  },
  "errors": {
    "generic": "Что-то пошло не так. Попробуй ещё раз.",
    "NOT_FOUND": "Не нашли такой заказ.",
    "FORBIDDEN": "Нет доступа.",
    "CONSENT_REQUIRED": "Сначала нужно согласие на обработку персональных данных.",
    "SERVICE_UNAVAILABLE": "Эта услуга пока недоступна.",
    "INVALID_PARAMS": "Проверь параметры заказа.",
    "SLOT_UNAVAILABLE": "Это время уже заняли. Выбери другое.",
    "ADDRESS_REQUIRED": "Укажи район и адрес.",
    "TRANSITION_NOT_ALLOWED": "Сейчас этот шаг недоступен. Обнови экран.",
    "CHECKLIST_INCOMPLETE": "Отметь все пункты чек-листа.",
    "PHOTO_REQUIRED": "Для этого пункта нужно фото.",
    "ESTIMATE_NOT_ACCEPTED": "Клиент ещё не согласовал смету.",
    "CANCEL_VIA_OPERATOR": "Услуга уже началась — отменить можно только через оператора.",
    "RESCHEDULE_VIA_OPERATOR": "Перенести можно только через оператора.",
    "AGENCY_CODE_INVALID": "Такого кода нет. Проверь код в договоре.",
    "AGENCY_ALREADY_SET": "Ты уже привязан к другому риэлторскому агентству.",
    "OFFER_NOT_ACTIVE": "Предложение уже неактуально.",
    "PROVIDER_BUSY": "Исполнитель занят в это время.",
    "ALREADY_ASSIGNED": "Заказ уже назначен.",
    "INVITE_INVALID": "Ссылка-приглашение недействительна. Попроси новую у оператора.",
    "NOT_PAID_STATE": "Этот заказ нельзя отметить оплаченным.",
    "BAD_CREDENTIALS": "Неверный логин или пароль.",
    "BAD_TOTP": "Неверный код. Проверь время на телефоне.",
    "LOGIN_THROTTLED": "Слишком много попыток. Подожди 15 минут.",
    "OWNER_ONLY": "Доступно только владельцу.",
    "NOT_LINKED": "Аккаунт не привязан.",
    "NOT_PROVIDER": "Доступно только исполнителям.",
    "CANNOT_DISABLE_SELF": "Нельзя отключить самого себя.",
    "AGENCY_CODE_FORMAT": "Код — латинские буквы и цифры.",
    "TOTP_ALREADY_ENABLED": "2FA уже настроена.",
    "ADMIN_LOGIN_REQUIRED": "Нужно войти.",
    "ADMIN_2FA_REQUIRED": "Нужно подтвердить вход кодом.",
    "INIT_DATA_MISSING": "Открой приложение через Telegram.",
    "INIT_DATA_BAD_HASH": "Открой приложение через Telegram.",
    "INIT_DATA_EXPIRED": "Сессия устарела. Открой приложение заново.",
    "BAD_FILE_TYPE": "Нужна фотография (JPG, PNG, WEBP).",
    "NO_FILE": "Файл не выбран.",
    "UPLOAD": "Не удалось загрузить фото.",
    "PHONE_INVALID": "Проверь номер телефона.",
    "REQUEST_THROTTLED": "Слишком много заявок подряд. Попробуй через 15 минут.",
    "CONTACT_INVALID": "Нужен телефон (+374…) или ник в Telegram (@username).",
    "NAME_REQUIRED": "Напишите, как к вам обращаться.",
    "PROVIDER_NOT_LINKED": "Исполнитель ещё не открыл рабочий бот по инвайту — написать ему пока некуда.",
    "CARD_EXPIRED": "QR устарел или недействителен — попросите клиента открыть карту заново.",
    "OFFER_NOT_AVAILABLE": "Это предложение недоступно на уровне клиента.",
    "OFFER_LIMIT_REACHED": "Лимит по этому предложению уже исчерпан.",
    "CONCIERGE_SUBSCRIBERS_ONLY": "Личный консьерж — для подписчиков Barev+ и Barev Elite. Пока пишите в поддержку — мы тоже поможем.",
    "ASSIGNEE_NO_ACCESS": "У этого сотрудника нет доступа к этому каналу.",
    "PROMO_INVALID": "Такого промокода нет",
    "PROMO_EXPIRED": "Промокод больше не действует",
    "PROMO_USED": "Этот промокод уже использован",
    "PROMO_NOT_FOR_SERVICE": "Промокод не действует на эту услугу",
    "POINTS_DUPLICATE_ORDER": "За этот заказ барики уже начислены.",
    "POINTS_REASON_REQUIRED": "Укажите причину.",
    "POINTS_BELOW_MIN": "Списать можно не меньше минимальной суммы.",
    "POINTS_NOT_ENOUGH": "Не хватает бариков.",
    "POINTS_OVER_SHARE": "Бариками можно оплатить только часть заказа.",
    "POINTS_OVER_LIMIT": "Сумма выше вашего лимита — нужно подтверждение суперадмина.",
    "POINTS_FINAL": "Эту операцию уже нельзя отменить.",
    "POINTS_REQUEST_CLOSED": "Запрос уже обработан или истёк.",
    "POINTS_TOO_MANY_REQUESTS": "У вас уже есть запросы на оплату бариками — дождитесь ответа.",
    "POINTS_WITH_PROMO": "Барики нельзя использовать вместе с промокодом.",
    "PAYMENT_UNAVAILABLE": "Онлайн-оплата сейчас недоступна — напиши оператору.",
    "PAYMENT_AMOUNT_OUT_OF_RANGE": "Эту сумму нельзя оплатить онлайн — оператор поможет с оплатой.",
    "ALREADY_SUBSCRIBED": "У тебя уже есть подписка с автопродлением.",
    "PAYMENT_PROVIDER_ERROR": "Платёжный сервис не ответил. Попробуй ещё раз чуть позже."
  },
  "client": {
    "nav": {
      "label": "Навигация",
      "home": "Главная",
      "services": "Услуги",
      "newOrder": "Новый заказ",
      "perks": "Скидки",
      "profile": "Профиль",
      "plan": "План",
      "docs": "Документы",
      "orders": "Заказы",
      "card": "Карта",
      "chat": "Чат"
    },
    "openInTelegram": {
      "title": "Открой в Telegram",
      "text": "Barev Club работает внутри Telegram. Нажми «Открыть приложение» в нашем боте."
    },
    "consent": {
      "title": "Почти готово",
      "text": "Чтобы оформлять заказы, нам нужно твоё согласие на обработку персональных данных: имени, адреса и деталей заказа. Их получает исполнитель твоего заказа и партнёры, перечисленные в политике, а хранятся они на сервере в Германии.",
      "policyLink": "Политика конфиденциальности",
      "accept": "Согласен, продолжить",
      "giftToast": "Подарок от риэлторского агентства активирован"
    },
    "home": {
      "hello": "Барев!",
      "guest": "Друг",
      "myOrders": "Мои заявки",
      "allOrders": "Все",
      "noOrders": "Заявок пока нет. Закажи первую услугу — это 2 минуты.",
      "repeatLast": "Повторить",
      "enterCode": "Код риэлторского агентства",
      "plusUntil": "Barev+ активен до {{date}}",
      "discount": "−{{pct}}% с Barev+",
      "upsellTitle": "Скидки до −{{pct}}% с Barev Elite",
      "upsellText": "Клининг, ремонт, трансфер, документы и подарки партнёров",
      "levelUntil": "{{plan}} активен до {{date}}",
      "now": "Сейчас",
      "moreActive": "Ещё активных: {{count}}",
      "orderTitle": "Заказать",
      "cardShow": "Показать QR",
      "free": "Бесплатный уровень",
      "chatTitle": "Любой вопрос — в чат",
      "chatText": "Ответим на твоём языке"
    },
    "services": {
      "title": "Услуги",
      "plusDiscount": "Твоя скидка Barev+: −{{pct}}%",
      "callback": "Оставить заявку",
      "yourDiscount": "Твоя скидка −{{pct}}%",
      "withElite": "С Barev Elite — скидка −{{pct}}%"
    },
    "order": {
      "unavailable": "Эта услуга появится совсем скоро.",
      "duration": "Примерно {{hours}} ч",
      "when": "Когда",
      "date": "Дата",
      "noSlots": "На этот день свободного времени нет. Выбери другой день.",
      "pickSlot": "Выбери время.",
      "address": "Адрес",
      "district": "Район",
      "districtPlaceholder": "Выбери район",
      "pickDistrict": "Выбери район.",
      "addressLabel": "Улица, дом, квартира",
      "addressPlaceholder": "ул. Пушкина, 10, кв. 15",
      "enterAddress": "Укажи адрес.",
      "note": "Заметка для исполнителя",
      "notePlaceholder": "Домофон, этаж, питомцы…",
      "payment": "Оплата",
      "paymentHint": "Оплата после выполнения. Онлайн-оплата появится позже.",
      "price": "Стоимость",
      "discount": "Скидка Barev+ −{{pct}}%",
      "plusHint": "С Barev+ было бы на {{pct}}% дешевле",
      "total": "Итого",
      "confirm": "Подтвердить заказ",
      "cancelPolicy": "Бесплатная отмена и перенос — не позднее чем за {{hours}} ч. Позже — удержание {{pct}}%.",
      "created": "Заказ #{{number}} создан",
      "extras": "Дополнительно",
      "add": "Добавить",
      "promo": "Промокод",
      "promoPlaceholder": "Промокод, если есть",
      "promoApply": "Применить",
      "promoRemove": "Убрать",
      "promoLine": "Промокод {{code}} −{{pct}}%",
      "promoWeaker": "Скидка по подписке больше — действует она"
    },
    "orders": {
      "title": "Мои заявки",
      "active": "Активные",
      "history": "История",
      "noHistory": "Здесь появятся завершённые заказы.",
      "order": "Заказать услугу"
    },
    "detail": {
      "progress": "Статус",
      "arrived": "на месте",
      "photoReport": "Фотоотчёт",
      "cancelFee": "Удержание за отмену",
      "reschedule": "Перенести",
      "rescheduleConfirm": "Перенести на это время",
      "rescheduled": "Заказ перенесён",
      "cancel": "Отменить заказ",
      "confirmCancelFree": "Отменить заказ? Отмена бесплатная.",
      "confirmCancelLate": "До начала меньше суток — удержим {{fee}} ({{pct}}%). Отменить?",
      "cancelled": "Заказ отменён",
      "cancelledWithFee": "Заказ отменён. Удержание: {{fee}}",
      "viaOperator": "Менее чем за {{hours}} ч до начала отменить или перенести заказ можно через оператора — напиши в бот.",
      "repeat": "Повторить заказ",
      "orderAgain": "Заказать снова",
      "providerLabel": {
        "CLEANING": "Клинер",
        "REPAIR": "Мастер",
        "TRANSFER": "Водитель",
        "LANGUAGE": "Преподаватель",
        "CAREER": "Консультант",
        "DOCUMENTS": "Специалист"
      },
      "when": "Когда",
      "where": "Где",
      "who": "Исполнитель",
      "whoPending": "подбираем",
      "payment": "Оплата",
      "ask": "Вопрос по заказу",
      "payOnline": "Оплатить онлайн · {{price}}",
      "payOnlineHint": "Картой через Tribute, в евро по курсу: {{amd}} ≈ {{rub}}",
      "payAwaiting": "Ждём подтверждение оплаты…",
      "paidOnline": "Оплата прошла, спасибо!"
    },
    "perks": {
      "title": "Скидки",
      "soonTitle": "Партнёры скоро",
      "soonText": "Кофейни, рестораны и подарки партнёров появятся здесь. Показывай клубную карту на кассе."
    },
    "profile": {
      "title": "Профиль",
      "fromAgency": "Клиент риэлторского агентства {{agency}}",
      "noAgency": "Без риэлторского агентства",
      "membership": "Членство Barev / Barev+",
      "codeTitle": "Код риэлторского агентства",
      "codeText": "Снял квартиру через риэлторское агентство-партнёр? Введи код из договора — получишь подарок от агентства.",
      "codePlaceholder": "Например, DOMIK",
      "codeAccepted": "Код принят: {{agency}}",
      "codeGift": "Код принят: {{agency}}. Подарок активирован!",
      "language": "Язык"
    },
    "membership": {
      "title": "Членство",
      "current": "Твой тариф",
      "howToGet": "Barev+ можно получить в подарок по коду риэлторского агентства. Онлайн-подписка появится совсем скоро.",
      "request": "Оформить {{plan}}",
      "requested": "Заявка отправлена — оператор свяжется",
      "requestHint": "Оператор напишет в Telegram, договорится об оплате и включит подписку.",
      "pendingTitle": "Заявка отправлена",
      "pendingText": "Оператор скоро свяжется, чтобы включить подписку.",
      "approx": "≈ {{amd}} · ≈ {{rub}} — оплата в евро",
      "pay": "Оформить {{plan}} за {{price}}/мес",
      "payRenew": "Включить автопродление · {{price}}/мес",
      "payHint": "Оплата картой через Tribute. Подписка продлевается каждый месяц, отключить можно здесь в любой момент.",
      "payOther": "Оплатить иначе — через оператора",
      "renewOn": "Автопродление включено",
      "nextCharge": "Следующее списание {{date}} — {{price}}",
      "renewOffButton": "Отключить автопродление",
      "renewOffConfirm": "Отключить автопродление? Подписка будет действовать до конца оплаченного месяца.",
      "renewOff": "Автопродление отключено",
      "switchHint": "У тебя подключена подписка {{plan}} с автопродлением. Чтобы сменить тариф, отключи её автопродление.",
      "awaitingTitle": "Ждём подтверждение оплаты",
      "awaitingText": "Обычно это несколько секунд. Подписка включится автоматически.",
      "paid": "Оплата прошла — подписка включена"
    },
    "segment": {
      "title": "Привет! Расскажи о себе",
      "sub": "Покажем то, что нужно именно тебе. Поменять можно в профиле.",
      "moving": "Переезжаю",
      "movingText": "План переезда по шагам, документы и консьерж",
      "living": "Уже живу в Армении",
      "livingText": "Услуги со скидкой, партнёры клуба и заказы",
      "profileTitle": "Мой сценарий"
    },
    "move": {
      "title": "Мой переезд",
      "daysLeft_one": "через {{count}} день",
      "daysLeft_few": "через {{count}} дня",
      "daysLeft_many": "через {{count}} дней",
      "daysLeft_other": "через {{count}} дня",
      "progress": "Готово {{done}} из {{total}} шагов",
      "noSteps": "Оператор свяжется и составит план — шаги появятся здесь.",
      "afterTitle": "Уже переехал?",
      "afterText": "Переключись в профиле на «Уже живу в Армении» — там услуги со скидкой и партнёры клуба.",
      "formHello": "{{name}}, начнём",
      "formTitle": "Соберём твой переезд",
      "formSub": "Ответь на пару вопросов — оператор составит план и посчитает цену.",
      "whenTitle": "Когда переезжаешь?",
      "packageTitle": "Что нужно?",
      "customTitle": "Отметь нужные услуги",
      "errPackage": "Выбери пакет.",
      "errWhen": "Выбери вариант или укажи дату.",
      "errEmpty": "Отметь хотя бы одну услугу.",
      "comment": "Комментарий",
      "commentHint": "Сколько вас, есть ли дети и питомцы, что важно",
      "submit": "Отправить план",
      "created": "План отправлен — оператор скоро свяжется",
      "status": {
        "TODO": "ждёт",
        "IN_PROGRESS": "в работе",
        "DONE": "готово",
        "SKIPPED": "не нужно"
      }
    },
    "docs": {
      "title": "Документы",
      "sub": "Что подготовить до переезда. Отмечай — так ничего не забудешь.",
      "progress": "Готово {{done}} из {{total}}",
      "needPlan": "Сначала собери план переезда — потом отмечай документы.",
      "ask": "Спросить консьержа"
    },
    "concierge": {
      "title": "Консьерж",
      "short": "Напиши в чат — ответим там же"
    },
    "request": {
      "title": "Оставить заявку",
      "sub": "Оператор свяжется, уточнит детали и оформит заказ.",
      "comment": "Что нужно сделать",
      "commentHint": "Например: течёт кран на кухне, удобно после 18:00",
      "submit": "Отправить заявку",
      "sentTitle": "Заявка №{{number}} отправлена",
      "sentText": "Оператор свяжется в рабочее время.",
      "back": "К услугам",
      "yourDiscount": "Твоя скидка по подписке −{{pct}}%"
    },
    "partners": {
      "howTo": "Покажи QR на кассе — сотрудник отсканирует его камерой. Код меняется каждую минуту, скриншот не сработает.",
      "cat": {
        "cafe": "Кафе",
        "restaurant": "Ресторан",
        "shop": "Магазин",
        "beauty": "Красота",
        "other": "Другое"
      },
      "qrLabel": "QR клубной карты",
      "qrRefresh": "обновится через {{seconds}} с",
      "allMembers": "всем членам клуба",
      "needLevel": "с {{level}}",
      "limit_ONCE": "первый визит",
      "limit_WEEK": "{{count}}× в неделю",
      "limit_MONTH": "{{count}}× в месяц",
      "used_ONCE": "уже получено",
      "used_WEEK": "снова со следующей недели",
      "used_MONTH": "снова со следующего месяца"
    },
    "chat": {
      "title": "Чат с Barev Club",
      "support": "Поддержка",
      "concierge": "Личный консьерж",
      "hint": "Это та же переписка, что в чате с ботом: ответ придёт и сюда, и в Telegram.",
      "empty": "Напишите, чем помочь, — ответим здесь.",
      "placeholder": "Сообщение…",
      "send": "Отправить",
      "attach": "Прикрепить фото или файл",
      "conciergeOnly": "Личный консьерж — в Barev+ и Barev Elite",
      "team": "Barev Club",
      "fileTooBig": "Файл больше 10 МБ",
      "file": "Файл"
    },
    "rate": {
      "title": "Как всё прошло?",
      "text": "Оценка поможет нам следить за качеством",
      "comment": "Комментарий — по желанию",
      "send": "Оценить",
      "thanks": "Спасибо за оценку!",
      "yours": "Твоя оценка",
      "change": "Изменить",
      "star": "{{count}} из 5",
      "prompt": "Оцени заказ"
    },
    "card": {
      "title": "Клубная карта",
      "partners": "Партнёры клуба",
      "plans": "Уровни и скидки"
    },
    "points": {
      "title": "Барики",
      "balance": "Доступно",
      "equals": "бариков ≈ {{amount}} ֏ · 1 барик = 1 ֏",
      "pending": "в ожидании: {{amount}}, станут доступны {{date}}",
      "burn": "{{amount}} сгорят {{date}} — любой заказ сохранит их",
      "pay": "Оплатить бариками",
      "enterCode": "Ввести код",
      "requestPending": "Запрос на оплату бариками ждёт подтверждения.",
      "rates": "Кэшбек по категориям",
      "plusWouldGet": "С Barev+ за последние 30 дней было бы ещё +{{amount}} бариков →",
      "streak": "Серия уборок",
      "streakLeft": "Ещё {{left}} — и кэшбек за уборку +{{bonus}}%. Перерыв между уборками — не больше {{days}} дней.",
      "streakMax": "Максимальная серия: +{{bonus}}% к кэшбеку за каждую уборку.",
      "route": "Маршрут первого месяца",
      "routeText": "Закажите услуги из 3 разных категорий до {{date}} — получите {{amount}} бариков. Сейчас: {{done}} из 3.",
      "history": "История",
      "empty": "Барики начисляются за каждый оплаченный заказ — кэшбек по ставке вашего уровня.",
      "availableFrom": "доступны с {{date}}",
      "until": "до {{date}}",
      "payHint": "Бариками можно оплатить до {{pct}}% заказа, минимум {{min}}. Команда подтвердит и пришлёт сумму к доплате.",
      "forOrder": "Заказ",
      "otherOrder": "Другой заказ (не в приложении)",
      "amount": "Сколько бариков списать",
      "max": "Максимум: {{max}}",
      "note": "Комментарий",
      "notePh": "Какой заказ и на какую сумму",
      "send": "Отправить запрос",
      "requested": "Запрос отправлен — ответим в чате.",
      "useInOrder": "Списать {{amount}} бариков",
      "useHint": "до {{pct}}% заказа · на счёте {{balance}}",
      "notWithPromo": "Не вместе с промокодом",
      "belowMin": "Списать можно от {{min}} · на счёте {{balance}}",
      "paidLine": "Оплачено бариками",
      "type": {
        "accrual": "Кэшбек",
        "bonus": "Бонус",
        "redemption": "Оплата бариками",
        "request": "Запрос на оплату",
        "reversal": "Отмена"
      },
      "status": {
        "PENDING": "в ожидании",
        "ACTIVE": "доступно",
        "SPENT": "потрачено",
        "EXPIRED": "сгорело",
        "REVERSED": "отменено",
        "REQUESTED": "ждёт подтверждения",
        "CONFIRMED": "списано",
        "REJECTED": "отклонено",
        "ACCRUAL": "начисление отменено",
        "REDEMPTION": "барики вернулись"
      }
    }
  },
  "pro": {
    "nav": {
      "label": "Навигация",
      "today": "Сегодня",
      "history": "История",
      "company": "Компания",
      "partner": "Партнёр"
    },
    "openInTelegram": {
      "title": "Открой в Telegram",
      "text": "Кабинет исполнителя открывается из бота Barev Pro."
    },
    "notLinked": {
      "title": "Аккаунт не привязан",
      "text": "Попроси у оператора ссылку-приглашение и открой её в Telegram."
    },
    "today": {
      "onShift": "На смене",
      "offShift": "Не на смене",
      "earned": "Заработок",
      "orders": "Заказов",
      "rating": "Рейтинг",
      "now": "Сейчас",
      "open": "Открыть заказ",
      "title": "Заказы на сегодня",
      "empty": "На сегодня заказов нет.",
      "upcoming": "Дальше"
    },
    "offer": {
      "title": "Новый заказ",
      "accept": "Принять",
      "decline": "Отклонить",
      "accepted": "Заказ принят",
      "declined": "Вы отказались от заказа",
      "left": "осталось"
    },
    "action": {
      "depart": "Выехал к клиенту",
      "arrived": "Я на месте",
      "startCleaning": "Начать уборку",
      "finishCleaning": "Завершить и отправить фото",
      "startWork": "Начать работу",
      "closeRepair": "Закрыть заказ",
      "atPickup": "Я в аэропорту",
      "passengerIn": "Пассажир в машине",
      "finishRide": "Завершить поездку",
      "scheduleLesson": "Запланировать урок",
      "openLesson": "Открыть урок",
      "startLesson": "Начать",
      "finishLesson": "Завершить урок",
      "openMeeting": "Открыть встречу",
      "startMeeting": "Начать",
      "finishMeeting": "Завершить"
    },
    "job": {
      "when": "Когда",
      "where": "Где",
      "client": "Клиент",
      "clientLanguage": "язык",
      "price": "Сумма",
      "checklist": "Чек-лист",
      "checklistFirst": "Чтобы завершить, отметь все пункты чек-листа и приложи фото.",
      "takePhoto": "Сделать фото",
      "retakePhoto": "Переснять",
      "confirmFinish": "Завершить заказ? Клиент получит уведомление и фотоотчёт.",
      "markPaid": "Клиент оплатил",
      "confirmPaid": "Подтвердить, что клиент оплатил {{amount}}?",
      "paidMarked": "Оплата отмечена"
    },
    "history": {
      "title": "История",
      "week": "7 дней",
      "month": "Этот месяц",
      "prevMonth": "Прошлый месяц",
      "earned": "Заработано",
      "done": "Выполнено",
      "empty": "За этот период заказов нет.",
      "ratePercent": "Ставка: {{value}}% от заказа",
      "rateFixed": "Ставка: {{value}} за заказ",
      "ratePreset": "Ставка: пресет «{{name}}»",
      "ratePartner": "Оплату за заказы назначает ваша компания"
    },
    "company": {
      "title": "Компания",
      "pending": "Ждут распределения",
      "noPending": "Все заказы распределены.",
      "assign": "Назначить сотрудника",
      "chooseStaff": "Кому отдать заказ",
      "assigned": "Назначенные",
      "noAssigned": "Пока пусто.",
      "assigned_ok": "Сотрудник назначен",
      "staff": "Сотрудники",
      "notLinked": "не в боте",
      "free": "свободен",
      "busy": "занят",
      "speaksLanguage": "язык клиента",
      "load_one": "{{count}} заказ в этот день",
      "load_few": "{{count}} заказа в этот день",
      "load_many": "{{count}} заказов в этот день",
      "load_other": "{{count}} заказа в этот день"
    },
    "partner": {
      "owner": "собственник",
      "staff": "сотрудник",
      "visits30_one": "{{count}} проверка за 30 дней",
      "visits30_few": "{{count}} проверки за 30 дней",
      "visits30_many": "{{count}} проверок за 30 дней",
      "visits30_other": "{{count}} проверки за 30 дней",
      "scan": "Сканировать QR клиента",
      "scanSub": "Покажет уровень клиента и что ему положено",
      "scanHint": "Наведите камеру на QR в приложении клиента",
      "noScanner": "Сканер работает только внутри Telegram. Можно ввести код вручную.",
      "manual": "Или вставьте код / ссылку из QR",
      "check": "Проверить",
      "valid": "{{name}} — {{level}}",
      "until": "подписка до {{date}}",
      "needLevel": "нужен {{level}}",
      "unlimited": "без ограничений",
      "redeemed": "Списано: {{offer}}",
      "offers": "Ваши предложения для клуба",
      "noOffers": "Предложений пока нет.",
      "offersHint": "Изменить предложения — напишите оператору клуба.",
      "allMembers": "всем членам клуба",
      "limit_ONCE": "только первый визит",
      "limit_WEEK": "{{count}}× в неделю",
      "limit_MONTH": "{{count}}× в месяц",
      "team": "Сотрудники",
      "invite": "Пригласить",
      "inviteQr": "QR-приглашение сотрудника",
      "inviteHint": "Сотрудник сканирует этот QR камерой телефона и нажимает Start. Код одноразовый, действует до {{time}}.",
      "inviteLink": "Или отправьте ссылку",
      "remove": "Убрать",
      "removeConfirm": "Убрать {{name}} из сотрудников?",
      "recent": "Последние проверки",
      "noRecent": "Проверок ещё не было.",
      "checked": "проверка карты"
    },
    "web": {
      "loginHint": "Откройте рабочий бот и нажмите «Открыть на компьютере» (или отправьте /web) — придёт ссылка для входа."
    },
    "cab": {
      "tab": {
        "orders": "Заказы",
        "staff": "Сотрудники",
        "money": "Доход",
        "settings": "Настройки"
      },
      "autoOn": "Автораспределение включено: новые заказы сами уходят свободным сотрудникам.",
      "income": "Ваш доход",
      "deadline": "назначьте до {{time}}",
      "offeredTo": "ждём ответа: {{name}}",
      "decline": "Отказаться",
      "declineConfirm": "Отказаться от заказа? Он вернётся в Barev Club.",
      "declined": "Заказ возвращён",
      "reassign": "Переназначить",
      "unassignConfirm": "Снять {{name}} с заказа? Заказ снова будет ждать назначения.",
      "unassigned": "Сотрудник снят с заказа",
      "gapHint": "Перерыв на дорогу между заказами: {{min}} мин.",
      "noStaff": "Сотрудников пока нет — добавьте их во вкладке «Сотрудники».",
      "dayLoad": "в этот день {{n}}/{{max}}",
      "weekLoad": "за неделю {{n}}",
      "district": "район",
      "check": {
        "ok": "Свободен",
        "busy": "Занят",
        "gap": "Не успеет доехать",
        "limit": "Лимит на день",
        "notLinked": "Не вошёл в бот",
        "gap_confirm": "Между заказами меньше времени на дорогу, чем задано. Всё равно назначить?",
        "limit_confirm": "У сотрудника уже лимит заказов или часов на этот день. Всё равно назначить?",
        "notLinked_confirm": "Сотрудник ещё не вошёл в рабочий бот и не получит уведомление. Назначить?",
        "busy_confirm": "Сотрудник занят в это время."
      },
      "addStaff": "Добавить сотрудника",
      "todayLoad": "сегодня {{n}}/{{max}}",
      "hoursMax": "до {{n}} ч в день",
      "off": "выключен",
      "staffAdded": "Сотрудник добавлен",
      "saved": "Сохранено",
      "inviteText": "Отправьте сотруднику эту ссылку: он откроет рабочий бот и сможет принимать заказы.",
      "done": "Готово",
      "f": {
        "name": "Имя",
        "phone": "Телефон",
        "languages": "Языки",
        "districts": "Районы (пусто — любые)",
        "days": "Рабочие дни",
        "from": "С",
        "to": "До",
        "maxOrders": "Заказов в день, макс.",
        "maxHours": "Часов в день, макс.",
        "loadHint": "Пусто — без ограничения. Автораспределение не даст сотруднику больше."
      },
      "save": "Сохранить",
      "resetInvite": "Новая ссылка для входа",
      "resetConfirm": "Сделать новую ссылку? Текущий вход сотрудника в бот отключится.",
      "turnOff": "Выключить",
      "turnOn": "Включить",
      "offConfirm": "Выключить {{name}}? Новые заказы ему не будут приходить.",
      "copy": "Скопировать",
      "copied": "Скопировано",
      "balance": "К выплате",
      "accrued": "Начислено",
      "paidOut": "Выплачено",
      "terms": {
        "COMMISSION": "Условия: Barev Club берёт {{pct}}% с оплаченного заказа, остальное — ваше. Зарплаты и расходы — на вас.",
        "PROFIT_SHARE": "Условия: зарплату клинеру ({{fot}}%) и налог ({{tax}}%) платит Barev Club, вам — {{pct}}% от остатка."
      },
      "byMonth": "По месяцам",
      "ordersN": "заказов: {{n}}",
      "byOrder": "По заказам",
      "noIncome": "Доход появится, когда клиент оплатит выполненный заказ.",
      "paidBy": "оплачено {{sum}}",
      "minus": "−ФОТ {{fot}}, −налог {{tax}}, ваши {{pct}}%",
      "minusCommission": "−{{pct}}% Barev Club",
      "payouts": "Выплаты",
      "payout": {
        "paid": "выплачено",
        "pending": "ожидает"
      },
      "auto": "Автораспределение",
      "autoHint": "Новый заказ сам предлагается лучшему свободному сотруднику: свободен по графику, есть время доехать, не превышен лимит; выше — кто знает язык клиента и работает в районе, у кого меньше заказов за неделю и выше рейтинг. Отказался или молчит — следующему.",
      "gap": "Перерыв на дорогу между заказами, мин",
      "gapMin": "Не меньше {{min}} мин",
      "timeoutHint": "Если заказ не назначен за {{min}} мин, он вернётся в Barev Club.",
      "managers": "Менеджеры",
      "you": "это вы",
      "remove": "Убрать",
      "removeManagerConfirm": "Убрать {{name}} из менеджеров?",
      "managerInvite": "Ссылка для ещё одного менеджера — по ней он откроет рабочий бот и получит доступ к кабинету:",
      "logout": "Выйти на этом компьютере",
      "wd": {
        "0": "Пн",
        "1": "Вт",
        "2": "Ср",
        "3": "Чт",
        "4": "Пт",
        "5": "Сб",
        "6": "Вс"
      }
    }
  },
  "bot": {
    "client": {
      "chooseLanguage": "Выбери язык · Choose your language · 选择语言 · Ընտրեք լեզուն · Elige tu idioma",
      "languageSet": "Язык: {{language}}",
      "fromAgency": "Привет! Ты пришёл от риэлторского агентства {{agency}} — у нас для тебя подарок.",
      "consentText": "Чтобы пользоваться Barev Club, нужно согласие на обработку персональных данных. Их получает исполнитель твоего заказа и партнёры, перечисленные в политике, а хранятся они на сервере в Германии.\n\n<a href=\"{{url}}\">Политика конфиденциальности</a>",
      "consentAccept": "Согласен",
      "giftActivated": "🎁 Подарок от риэлторского агентства: {{plan}} активен до {{date}}. Скидки на услуги уже применяются.",
      "welcome": "Ереван — как дома. С первого дня.\n\nЗаказывай клининг и другие услуги, следи за статусом и пользуйся скидками партнёров — всё в приложении.",
      "openApp": "Открыть приложение",
      "enterCode": "Ввести код риэлторского агентства",
      "changeLanguage": "Сменить язык",
      "codePrompt": "Отправь код риэлторского агентства из договора аренды.",
      "codeAccepted": "Код принят: {{agency}}.",
      "help": "Нажми «Открыть приложение», чтобы заказать услугу. Команды: /app — приложение, /code — код риэлторского агентства, /language — язык.",
      "cmdStart": "Начать",
      "cmdApp": "Открыть приложение",
      "cmdCode": "Ввести код риэлторского агентства",
      "cmdLanguage": "Сменить язык",
      "cmdHelp": "Помощь",
      "webRequestOrdered": "Заявка №{{request}} принята и оформлена как заказ №{{order}} на {{date}}. Статус — в приложении.",
      "webRequestLinked": "Заявка №{{request}} принята. Оператор свяжется с тобой и подтвердит время.",
      "conciergeReceived": "Передали консьержу — ответим здесь, в этом чате.",
      "supportReceived": "Передали в поддержку — ответим здесь, в этом чате.",
      "channelSupport": "Теперь вы пишете в поддержку. Просто отправьте сообщение, фото или файл.",
      "channelConcierge": "Теперь вы пишете личному консьержу. Просто отправьте сообщение, фото или файл.",
      "cmdSupport": "Написать в поддержку",
      "cmdConcierge": "Написать консьержу (Barev+)",
      "rated": "Спасибо за оценку! {{stars}}",
      "ratedLow": "Жаль, что не всё прошло хорошо. Напиши здесь, что случилось, — команда разберётся.",
      "wr": {
        "intro": "Заявка №{{request}} у нас. Осталось пару вопросов, чтобы оформить заказ.",
        "askDistrict": "В каком районе квартира?",
        "askAddress": "Напиши адрес: улица, дом, квартира.",
        "askDay": "Когда удобно? Выбери день.",
        "askTime": "Выбери время {{day}}:",
        "dayFull": "На этот день время уже разобрали. Выбери другой день.",
        "noSlots": "Свободного времени в ближайшие дни нет — оператор свяжется с тобой и подберёт время."
      },
      "cmdBalance": "Баланс бариков",
      "cmdHistory": "История бариков",
      "points": {
        "balance": "🪙 Барики: {{balance}} (≈ {{balance}} ֏)",
        "pending": "⏳ В ожидании: {{pending}}, станут доступны {{date}}",
        "burn": "🔥 Сгорят {{date}}, если не будет заказов",
        "empty": "Операций с бариками пока нет.",
        "open": "Открыть барики",
        "type": {
          "accrual": "Кэшбек",
          "bonus": "Бонус",
          "redemption": "Оплата бариками",
          "request": "Запрос на оплату",
          "reversal": "Отмена"
        },
        "status": {
          "PENDING": "в ожидании",
          "ACTIVE": "доступно",
          "SPENT": "потрачено",
          "EXPIRED": "сгорело",
          "REVERSED": "отменено",
          "REQUESTED": "ждёт подтверждения",
          "CONFIRMED": "списано",
          "REJECTED": "отклонено",
          "ACCRUAL": "начисление отменено",
          "REDEMPTION": "барики вернулись"
        }
      }
    },
    "pro": {
      "notLinked": "Этот бот — для исполнителей Barev Club. Попроси у оператора ссылку-приглашение.",
      "linkedProvider": "Готово, {{name}}! Аккаунт привязан.",
      "linkedDispatcher": "Готово! Вы диспетчер компании «{{name}}».",
      "youAreProvider": "{{name}} · {{role}}",
      "youAreDispatcher": "Диспетчер компании «{{company}}»",
      "welcome": "Здесь приходят новые заказы. Принимайте их кнопками в сообщении, а заказы на день ведите в кабинете.",
      "openCabinet": "Открыть кабинет",
      "messageReceived": "Передали оператору — ответ придёт сюда.",
      "openWeb": "💻 Открыть на компьютере",
      "webLink": "Ссылка на кабинет для браузера (действует 15 минут, одноразовая):\n{{url}}"
    },
    "admin": {
      "hello": "{{name}}, сюда приходят уведомления из админки Barev Club.",
      "linked": "Готово, {{name}}! Уведомления админки будут приходить сюда. Отвечать клиентам можно кнопкой «Ответить».",
      "linkInvalid": "Ссылка устарела — нажмите «Подключить Telegram» в админке ещё раз.",
      "notAdmin": "Этот Telegram не подключён к админке.",
      "open": "Открыть в админке",
      "reply": "Ответить",
      "replyPrompt": "Ответ для {{name}} — напишите сообщением. /cancel — отмена.",
      "replyPlaceholder": "Текст ответа",
      "replySent": "Отправлено: {{name}}",
      "replyCancelled": "Ответ отменён.",
      "provider": "исполнитель",
      "newOrder": "Новый заказ #{{number}}",
      "newLead": "Заявка на переезд №{{number}}",
      "newRequest": "Заявка из приложения №{{number}}",
      "newWebRequest": "Заявка с сайта №{{number}}",
      "loginOk": "Вход в админку подтверждён — вернитесь в браузер.",
      "loginExpired": "Ссылка для входа устарела — обновите страницу админки.",
      "channelSupport": "Поддержка",
      "channelConcierge": "Консьерж",
      "file": "файл",
      "chatAssigned": "{{by}} передал(а) вам диалог: {{name}}",
      "order": "Заказ №{{number}}",
      "noOrder": "Сейчас без заказа",
      "autoFailed": "Не нашли свободного исполнителя для заказа №{{number}} — назначьте вручную.",
      "partnerDeclined": "Партнёр «{{partner}}» отказался от заказа №{{number}} — назначьте заново",
      "partnerExpired": "Партнёр «{{partner}}» не назначил сотрудника на заказ №{{number}} вовремя — назначьте заново",
      "noTime": "время не указано",
      "noAddress": "адрес не указан",
      "points": {
        "forOrder": "Заказ №{{number}} на {{sum}}",
        "confirm": "✅ Подтвердить",
        "reject": "Отклонить",
        "request": "Клиент просит оплатить бариками: {{amount}}",
        "balance": "баланс {{balance}}",
        "suggestions": "Новые предложения бариков: {{count}} (всего в очереди {{open}})",
        "overLimit": "{{by}} хочет провести {{amount}} бариков — выше лимита, нужно ваше подтверждение",
        "mismatch": "Сверка бариков: у {{count}} клиентов баланс расходился с журналом — исправлено, проверьте журнал",
        "confirmed": "Списано {{amount}} бариков",
        "rejected": "Запрос отклонён",
        "help": "Начислить за заказ: /barik <телефон или @username> <сумма заказа> [категория]\nКатегории: cleaning, documents, learning, repair, transfer",
        "noClient": "Клиент не найден",
        "preview": "Начислить {{amount}} бариков {{name}} за {{what}} {{sum}} ֏ ({{tier}}, {{rate}}%). Станут доступны {{date}}.",
        "accrue": "🪙 Начислить",
        "done": "Начислено {{amount}} бариков",
        "needsApproval": "Сумма выше лимита — отправлено суперадмину на подтверждение",
        "zero": "Сумма получилась 0 — начислять нечего"
      },
      "pay": {
        "subscription": "Подписка {{plan}}",
        "order": "Заказ #{{number}} · {{service}}",
        "paid": "Онлайн-оплата",
        "renewed": "Продление подписки",
        "refunded": "Возврат онлайн-оплаты",
        "cancelled": "Автопродление остановлено",
        "attention": "Оплата требует внимания",
        "attentionHint": "Клиент оплатил онлайн, но заказ уже оплачен или отменён — нужен возврат в Tribute.",
        "fromSite": "Оплата с сайта (Telegram ещё не привязан)"
      }
    },
    "partner": {
      "valid": "{{name}} — {{level}}, карта действует",
      "until": "подписка до {{date}}",
      "needLevel": "нужен {{level}}",
      "noOffers": "У партнёра пока нет предложений — напишите оператору клуба.",
      "notPartner": "Это клубная карта Barev Club. Проверить её может только партнёр клуба.",
      "redeem": "Списать",
      "redeemed": "Списано",
      "redeemedText": "Списано: {{offer}}",
      "linkedOwner": "Готово! Вы — собственник «{{partner}}». Откройте кабинет: там предложения, сотрудники и сканер QR.",
      "linkedStaff": "Готово! Вы — сотрудник «{{partner}}». Сканируйте QR клиентов камерой или в кабинете.",
      "youAreOwner": "Собственник «{{partner}}»",
      "youAreStaff": "Сотрудник «{{partner}}»",
      "left_ONCE": "первый визит",
      "left_WEEK": "осталось на этой неделе: {{count}}",
      "left_MONTH": "осталось в этом месяце: {{count}}",
      "used_ONCE": "уже использовано",
      "used_WEEK": "на этой неделе уже использовано",
      "used_MONTH": "в этом месяце уже использовано"
    }
  },
  "notify": {
    "openOrder": "Открыть заказ",
    "duration": "{{minutes}} мин",
    "clientLanguage": "Язык клиента",
    "created": "Заказ принят: {{when}}. Итого {{total}}. Сообщим, когда назначим исполнителя.",
    "rescheduled": "Заказ перенесён на {{when}}.",
    "reminder24": "Напоминаем: завтра, {{when}}.",
    "reminder1": "Через час: {{when}}.",
    "event": {
      "arrived": "Исполнитель на месте.",
      "openLesson": "Урок скоро начнётся.",
      "openMeeting": "Встреча скоро начнётся."
    },
    "status": {
      "CLEANING": {
        "NEW": "Ищем нового клинера на {{when}}.",
        "ASSIGNED": "Клинер {{provider}} назначен на {{when}}.",
        "EN_ROUTE": "Клинер {{provider}} уже едет к тебе.",
        "CLEANING": "Уборка началась.",
        "DONE": "Уборка завершена. Фотоотчёт — в приложении.",
        "CANCELLED": "Заказ отменён."
      },
      "REPAIR": {
        "NEW": "Ищем мастера на {{when}}.",
        "ASSIGNED": "Мастер {{provider}} назначен на {{when}}.",
        "ON_SITE": "Мастер на месте и готовит смету.",
        "ESTIMATE_APPROVED": "Смета согласована.",
        "REPAIRING": "Ремонт начался.",
        "DONE": "Ремонт завершён.",
        "CANCELLED": "Заказ отменён."
      },
      "TRANSFER": {
        "NEW": "Ищем водителя на {{when}}.",
        "ASSIGNED": "Водитель {{provider}} назначен на {{when}}.",
        "DRIVER_WAITING": "Водитель ждёт тебя.",
        "RIDE_IN_PROGRESS": "Поездка началась.",
        "COMPLETED": "Поездка завершена.",
        "CANCELLED": "Заказ отменён."
      },
      "LANGUAGE": {
        "ENROLLED": "Ты записан на курс.",
        "LESSON_SCHEDULED": "Урок запланирован: {{when}}.",
        "LESSON_IN_PROGRESS": "Урок начался.",
        "LESSON_DONE": "Урок завершён.",
        "COMPLETED": "Пакет уроков пройден!",
        "CANCELLED": "Заказ отменён."
      },
      "CAREER": {
        "NEW": "Ищем консультанта.",
        "CONSULTANT_ASSIGNED": "Консультант {{provider}} назначен.",
        "RESUME_RECEIVED": "Резюме получено.",
        "MEETING": "Встреча началась.",
        "PLAN_SENT": "План поиска работы готов.",
        "CANCELLED": "Заказ отменён."
      },
      "DOCUMENTS": {
        "NEW": "Заявка принята.",
        "DOCS_REVIEW": "Проверяем документы.",
        "NEEDS_MORE_DOCS": "Нужны дополнительные документы — подробности в приложении.",
        "SUBMITTED": "Документы поданы.",
        "DONE": "Документ готов!",
        "CANCELLED": "Заказ отменён."
      }
    },
    "pro": {
      "offerTitle": "Новый заказ для вас",
      "offerTimeout": "Ответьте в течение {{minutes}} мин, иначе заказ уйдёт другому исполнителю.",
      "assignedByDispatcher": "Диспетчер назначил вам заказ на {{when}}.",
      "cancelled": "Клиент или оператор отменил заказ на {{when}}.",
      "rescheduled": "Заказ перенесён на {{when}}.",
      "unassigned": "Заказ на {{when}} снят с вас.",
      "reminder24": "Завтра заказ: {{when}}.",
      "reminder1": "Через час заказ: {{when}}.",
      "orderEdited": "Состав заказа на {{when}} изменён — откройте заказ."
    },
    "dispatcher": {
      "newOrder": "Новый заказ для компании на {{when}}. Назначьте сотрудника в кабинете.",
      "returned": "Сотрудник отказался от заказа на {{when}}. Назначьте другого.",
      "noStaff": "Нет свободного сотрудника на заказ {{when}} — назначьте вручную в кабинете.",
      "expired": "Заказ на {{when}} вернулся в Barev Club: сотрудника не назначили вовремя."
    },
    "openPlan": "Открыть приложение",
    "concierge": "Консьерж Barev Club",
    "subscriptionActivated": "{{plan}} включён до {{date}}. Скидки уже в ценах услуг.",
    "operator": "Оператор Barev Club",
    "support": "Поддержка Barev Club",
    "rateAsk": "Как всё прошло? Оцени, пожалуйста, — это займёт секунду:",
    "points": {
      "open": "Мои барики",
      "pending": "🪙 +{{amount}} бариков за {{what}} {{date}}. Станут доступны {{available}}.",
      "active": "🪙 +{{amount}} бариков за {{what}}. Баланс: {{balance}}.",
      "bonus": "🎁 +{{amount}} бариков в подарок: {{what}}. Действуют до {{until}}.",
      "bonusNoTtl": "🎁 +{{amount}} бариков в подарок: {{what}}.",
      "housewarming": "на новоселье от {{agency}}",
      "activated": "✅ {{amount}} бариков доступны. Баланс: {{balance}}.",
      "redeemed": "Оплачено бариками: {{amount}}. К доплате: {{due}}. Остаток: {{balance}}.",
      "redeemedNoOrder": "Списано бариков: {{amount}}. Остаток: {{balance}}.",
      "requestExpired": "Запрос на оплату бариками истёк. Если нужно — отправьте новый.",
      "rejected": "Запрос на оплату бариками отклонён: {{reason}}",
      "declinedGeneric": "напишите нам в чат, обсудим.",
      "orderCancelled": "заказ отменён",
      "returned": "↩️ {{amount}} бариков вернулись на счёт. Баланс: {{balance}}.",
      "reversed": "Начисление {{what}} отменено: {{reason}}. Баланс: {{balance}}.",
      "expiring": "⏰ Через {{days}} дн. сгорят {{amount}} бариков. Любой заказ сохранит их.",
      "expired": "{{amount}} бариков сгорели — давно не было заказов.",
      "orderEdited": "заказ изменён — начислим по новой сумме"
    },
    "orderEdited": "Состав заказа изменён. Итого к оплате: {{total}}."
  },
  "admin": {
    "nav": {
      "orders": "Заказы",
      "clients": "Клиенты",
      "providers": "Исполнители",
      "companies": "Партнёры услуг",
      "services": "Услуги и цены",
      "agencies": "Риэлторские агентства",
      "settings": "Настройки",
      "presets": "Ставки",
      "webRequests": "Заявки с сайта",
      "leads": "Переезд",
      "concierge": "Консьерж",
      "requests": "Заявки из приложения",
      "partners": "Партнёры клуба",
      "telegram": "Уведомления",
      "templates": "Шаблоны переезда"
    },
    "roles": {
      "OWNER": "Владелец",
      "OPERATOR": "Оператор"
    },
    "logout": "Выйти",
    "save": "Сохранить",
    "saved": "Сохранено",
    "edit": "Изменить",
    "add": "Добавить",
    "active": "Активен",
    "copy": "Копировать",
    "copied": "Скопировано",
    "login": {
      "title": "Вход в админку",
      "email": "Логин или email",
      "password": "Пароль",
      "submit": "Войти",
      "totpTitle": "Код подтверждения",
      "setupTitle": "Настройка 2FA",
      "setupText": "Отсканируй QR-код в приложении-аутентификаторе (Google Authenticator, 1Password) и введи код.",
      "qrAlt": "QR-код для приложения-аутентификатора",
      "code": "Код из приложения",
      "verify": "Подтвердить"
    },
    "summary": {
      "ordersToday": "Заказов сегодня",
      "unassigned": "Без исполнителя",
      "revenueToday": "Выручка за день",
      "freeProviders": "Свободны / на смене"
    },
    "kanban": {
      "title": "Заказы",
      "category": "Направление",
      "allCategories": "Все направления",
      "service": "Услуга",
      "allServices": "Все услуги",
      "date": "Дата",
      "search": "Поиск: №, имя, адрес",
      "showCancelled": "Отменённые",
      "newOrderTitle": "Новый заказ",
      "awaiting": "Ждёт ответа: {{name}}",
      "toCompany": "Назначен на компанию: {{name}}",
      "col": {
        "new": "Новые",
        "assigned": "Назначены",
        "in_progress": "В работе",
        "done": "Готово",
        "cancelled": "Отменённые"
      }
    },
    "order": {
      "when": "Когда",
      "min": "мин",
      "params": "Параметры",
      "address": "Адрес",
      "note": "Заметка",
      "client": "Клиент",
      "agency": "агентство",
      "provider": "Исполнитель",
      "price": "Цена",
      "cancelFee": "удержание",
      "payment": "Оплата",
      "actions": "Действия",
      "comment": "Комментарий к действию",
      "unassign": "Снять исполнителя",
      "confirmUnassign": "Снять исполнителя? Заказ вернётся в «Новые».",
      "markPaid": "Отметить оплату",
      "confirmPaid": "Отметить, что получено {{amount}}?",
      "cancel": "Отменить заказ",
      "confirmCancel": "Отменить заказ? Клиент получит уведомление.",
      "checklist": "Чек-лист",
      "photo": "Фото",
      "history": "История",
      "offers": "Предложения",
      "assignTitle": "Назначение",
      "assignTo": "Назначить: {{name}}",
      "assign": "Назначить",
      "company": "компания",
      "noCandidates": "Нет свободных исполнителей на это время.",
      "chooseManually": "Выбрать вручную ({{count}})",
      "hideOthers": "Скрыть",
      "busy": "Заняты",
      "load_one": "{{count}} заказ в этот день",
      "load_few": "{{count}} заказа в этот день",
      "load_many": "{{count}} заказов в этот день",
      "load_other": "{{count}} заказа в этот день",
      "offered": "Заказ отправлен исполнителю",
      "statusChanged": "Статус изменён",
      "cancelled": "Заказ отменён",
      "unassigned": "Исполнитель снят",
      "paid": "Оплата отмечена"
    },
    "reasons": {
      "language": "язык клиента",
      "district": "район",
      "onShift": "на смене",
      "lowLoad": "свободный день"
    },
    "actors": {
      "CLIENT": "клиент",
      "PROVIDER": "исполнитель",
      "DISPATCHER": "диспетчер",
      "ADMIN": "оператор",
      "SYSTEM": "система"
    },
    "offerStatus": {
      "OFFERED": "ждёт ответа",
      "ACCEPTED": "принято",
      "DECLINED": "отказ",
      "EXPIRED": "истекло",
      "REVOKED": "отозвано"
    },
    "events": {
      "accepted": "Исполнитель принял заказ",
      "dispatcherAssigned": "Диспетчер назначил сотрудника",
      "assignedToCompany": "Передан компании",
      "offerDeclined": "Исполнитель отказался",
      "offerExpired": "Время на ответ истекло",
      "rescheduled": "Перенос",
      "unassigned": "Исполнитель снят",
      "depart": "Выехал к клиенту",
      "arrived": "На месте",
      "startCleaning": "Начал уборку",
      "finishCleaning": "Завершил уборку",
      "startWork": "Начал работу",
      "closeRepair": "Закрыл заказ",
      "atPickup": "Водитель на месте подачи",
      "passengerIn": "Пассажир в машине",
      "finishRide": "Поездка завершена",
      "scheduleLesson": "Урок запланирован",
      "openLesson": "Урок открыт",
      "startLesson": "Урок начат",
      "finishLesson": "Урок завершён",
      "openMeeting": "Встреча открыта",
      "startMeeting": "Встреча начата",
      "finishMeeting": "Встреча завершена",
      "editedByStaff": "Команда изменила состав",
      "checklistByStaff": "Команда отметила пункт чек-листа",
      "checklistUncheckedByStaff": "Команда сняла отметку чек-листа"
    },
    "weekdays": {
      "0": "Пн",
      "1": "Вт",
      "2": "Ср",
      "3": "Чт",
      "4": "Пт",
      "5": "Сб",
      "6": "Вс"
    },
    "schedule": {
      "from": "С",
      "to": "До",
      "works": "Рабочий день"
    },
    "rate": {
      "PERCENT": "% от заказа",
      "FIXED": "Фикс за заказ"
    },
    "providers": {
      "add": "Добавить исполнителя",
      "name": "Имя",
      "phone": "Телефон",
      "role": "Роль",
      "company": "Компания",
      "freelancer": "Частный исполнитель",
      "languages": "Языки",
      "districts": "Районы",
      "rate": "Ставка",
      "rateType": "Тип ставки",
      "ratePercent": "Процент от заказа",
      "rateFixed": "Сумма за заказ, ֏",
      "companyRate": "ставка компании",
      "rating": "Рейтинг",
      "schedule": "График",
      "telegram": "Telegram",
      "linked": "привязан",
      "resetInvite": "Новая ссылка-приглашение",
      "preset": "Ставка",
      "ownRate": "Индивидуальная ставка"
    },
    "companies": {
      "add": "Добавить компанию",
      "name": "Название",
      "phone": "Контактный телефон",
      "roles": "Какие заказы берёт",
      "employees": "Сотрудники",
      "dispatchers": "Диспетчеры",
      "dispatcherInvite": "Ссылка для диспетчера"
    },
    "services": {
      "plusDiscount": "Скидка Barev+",
      "active": "доступна",
      "inactive": "скрыта",
      "availableToOrder": "Доступна для заказа",
      "prices": "Цены и длительность",
      "variant": "Вариант",
      "base": "Цена за 1 комнату, ֏",
      "perRoom": "За каждую следующую, ֏",
      "baseMinutes": "Минут на 1 комнату",
      "perRoomMinutes": "Минут за следующую",
      "price": "Цена, ֏",
      "minutes": "Длительность, мин",
      "lateFee": "Удержание при поздней отмене, %",
      "step": "Шаг слотов, мин",
      "dayStart": "Начало дня, ч",
      "dayEnd": "Конец дня, ч",
      "leadHours": "Минимум часов до начала",
      "horizon": "Запись на дней вперёд",
      "perBathroom": "За каждый следующий санузел, ֏",
      "perBathroomMinutes": "Минут за санузел",
      "extras": "Дополнительные услуги",
      "extra": "Услуга",
      "extraPrice": "Цена, ֏",
      "extraMinutes": "Минут на единицу",
      "eliteDiscount": "Скидка Elite"
    },
    "agencies": {
      "add": "Добавить риэлторское агентство",
      "name": "Название",
      "code": "Код",
      "commission": "Вознаграждение, %",
      "contact": "Контакт",
      "leads": "Лиды",
      "links": "Ссылки для QR",
      "bot": "Сразу в бота",
      "landing": "Через лендинг",
      "hint": "Клиент закреплён за агентством {{months}} мес. с первого входа. Вознаграждение считается только с оплаченных заказов."
    },
    "clients": {
      "name": "Клиент",
      "language": "Язык",
      "source": "Источник",
      "membership": "Членство",
      "orders": "Заказов",
      "since": "С нами с",
      "noConsent": "нет согласия",
      "source_organic": "Сам",
      "source_deeplink": "Ссылка агентства",
      "source_manual_code": "Код вручную",
      "grant": "+30 дней Barev+",
      "grantConfirm": "Выдать клиенту 30 дней Barev+?",
      "grantElite": "Elite на 30 дней",
      "grantEliteConfirm": "Выдать клиенту Barev Elite на 30 дней?",
      "segment_MOVING": "переезжает",
      "segment_LIVING": "живёт в Армении"
    },
    "settings": {
      "cancel_freeHours": "Бесплатная отмена не позднее чем за, ч",
      "agency_attributionMonths": "Клиент закреплён за агентством, мес.",
      "agency_defaultCommissionPct": "Вознаграждение агентства по умолчанию, %",
      "barevPlus_giftDays": "Лендинг: «первые N дней в подарок» (сам подарок задаётся у агентства)",
      "barevPlus_monthlyPrice": "Цена Barev+ в месяц, ֏",
      "offer_acceptTimeoutMinutes": "Время на ответ исполнителя, мин",
      "chat_closeAfterHours": "Чат закрывается через, ч после заказа",
      "files_retentionDays": "Хранить сканы документов, дней",
      "consent_version": "Версия политики ПДн",
      "paymentMethods": "Способы оплаты",
      "code": "Код",
      "name": "Название",
      "admins": "Администраторы",
      "role": "Роль",
      "tempPassword": "Временный пароль (от 10 символов)",
      "addAdmin": "Добавить администратора",
      "disable": "Отключить",
      "enable": "Включить",
      "barevPlus_maxDiscountPct": "Barev+: скидка до, %",
      "elite_monthlyPrice": "Barev Elite: цена в месяц, ֏",
      "elite_maxDiscountPct": "Barev Elite: скидка до, %",
      "relocation_hotelWithPlus": "Главная: отель с Barev+, ֏/сутки",
      "relocation_hotelBase": "Главная: отель без подписки, ֏/сутки",
      "relocation_consultation": "Главная: консультация по переезду, ֏",
      "docs_fromPrice": "/live: документы «от», ֏",
      "docs_socialCardPrice": "Соцкарта под ключ, ֏",
      "residence_escortFrom": "ВНЖ: сопровождение «от», ֏",
      "residence_stateFee": "ВНЖ: госпошлина на 1 год, ֏",
      "transfer_standardPrice": "Трансфер «Стандарт», ֏",
      "transfer_premiumPrice": "Трансфер «Премиум», ֏",
      "assign_auto": "Автораспределение заказов",
      "assign_maxAutoOffers": "Сколько исполнителей пробовать автоматически",
      "sales_bonusPerVenue": "Бонус продажника за заведение, ֏",
      "sales_bonusPerAgency": "Бонус продажника за агентство, ֏",
      "sales_bonusAgencyPct": "Бонус продажника: % выручки клиентов его агентств",
      "sales_bonusAgencyMonths": "…сколько месяцев после подключения агентства",
      "partner_fotPct": "Партнёры «расходы наши»: ФОТ клинера, % от заказа",
      "partner_taxPct": "Партнёры «расходы наши»: налог, %",
      "partner_minTravelGapMinutes": "Партнёры: минимальный перерыв между заказами сотрудника, мин",
      "partner_acceptTimeoutMinutes": "Партнёры: за сколько минут назначить сотрудника, иначе заказ вернётся",
      "points_pendingHours": "Барики: доступны через N часов после услуги",
      "points_maxSharePct": "Барики: можно оплатить до N% заказа",
      "points_minRedeem": "Барики: минимум за одно списание",
      "points_burnDays": "Барики: сгорают через N дней без активности",
      "points_warnDays1": "Барики: первое предупреждение за N дней",
      "points_warnDays2": "Барики: второе предупреждение за N дней",
      "points_requestTtlHours": "Барики: запрос клиента ждёт N часов",
      "points_streakGapDays": "Барики: серия уборок — перерыв не больше N дней",
      "points_diffHighlightPct": "Барики: подсветить ручную сумму, если отличается больше чем на N%",
      "points_supportCanManage": "Поддержка тоже может начислять и списывать барики (с лимитами)",
      "points_opMaxPerOperation": "Лимит поддержки на одну операцию, барики",
      "points_opMaxPerDay": "Лимит поддержки в сутки, барики",
      "barevPlus_monthlyPriceEur": "Barev+: цена в месяц для онлайн-оплаты, €",
      "elite_monthlyPriceEur": "Barev Elite: цена в месяц для онлайн-оплаты, €",
      "fx_eurAmd": "Курс: ֏ за 1 € (пересчёт заказов в евро)",
      "fx_eurRub": "Курс: ₽ за 1 € (подсказка «≈ ₽» клиенту)"
    },
    "presets": {
      "add": "Добавить пресет",
      "hint": "Пресет задаёт выплату клинеру по каждой строке цены: фикс в драмах или процент. Процент считается от цены до скидки Barev+. Пресет назначается исполнителю в его карточке.",
      "providers_one": "{{count}} исполнитель",
      "providers_few": "{{count}} исполнителя",
      "providers_many": "{{count}} исполнителей",
      "providers_other": "{{count}} исполнителя",
      "room": "Каждая доп. комната",
      "bathroom": "Каждый доп. санузел",
      "name": "Название пресета",
      "applyAll": "Один процент на всё",
      "line": "Строка цены",
      "type": "Тип",
      "value": "Значение",
      "percent": "% от строки",
      "fixed": "Фикс {{unit}}",
      "perOrder": "за заказ",
      "perRoom": "за комнату",
      "perBathroom": "за санузел"
    },
    "webRequests": {
      "all": "Все",
      "status_NEW": "Не открыл бота",
      "status_LINKED": "Нужен звонок",
      "status_ORDERED": "Заказ создан",
      "status_CANCELLED": "Отменена",
      "number": "№",
      "when": "Желаемое время",
      "what": "Уборка",
      "contact": "Контакт",
      "address": "Адрес",
      "price": "Цена",
      "status": "Статус",
      "note": "Заметка оператора",
      "notePlaceholder": "Созвонились, перезвонить…",
      "saveNote": "Сохранить",
      "cancel": "Отменить",
      "cancelConfirm": "Отменить заявку №{{number}}?",
      "reopen": "Вернуть в работу",
      "order": "Заказ №{{number}}",
      "created": "Создана {{date}}",
      "empty": "Заявок пока нет. Они появятся здесь, как только кто-то заполнит форму на barevclub.com/clean."
    },
    "leads": {
      "title": "Заявки на переезд",
      "all": "Все",
      "empty": "Заявок из квиза пока нет.",
      "number": "№",
      "contact": "Контакт",
      "plan": "Когда",
      "package": "Пакет",
      "status": "Статус",
      "note": "Заметка",
      "created": "создана {{date}}",
      "unfinished": "не дошёл до конца квиза",
      "moved": "уже живёт в Армении",
      "status_NEW": "Новая",
      "status_IN_WORK": "В работе",
      "status_DONE": "Готово",
      "status_CANCELLED": "Отменена",
      "budget": "{{from}}–{{to}} ֏/сутки",
      "inApp": "в приложении",
      "stepNote": "Комментарий для клиента",
      "stepsInApp": "План переезда — клиент видит шаги в приложении и получает сообщение при смене статуса",
      "stepsNoApp": "План переезда — клиент ещё не открыл приложение",
      "addStep": "Добавить шаг",
      "addDoc": "Добавить документ",
      "custom": "Свой пункт…",
      "customPlaceholder": "Название для этого клиента",
      "docsTitle": "Документы клиента — готово {{done}} из {{total}}",
      "remove": "Убрать у клиента",
      "removeStepConfirm": "Убрать шаг «{{name}}» из плана клиента?"
    },
    "concierge": {
      "empty": "Сообщений пока нет. Клиенты пишут боту — переписка появится здесь.",
      "placeholder": "Ответ придёт клиенту в чат с ботом. ⌘+Enter — отправить",
      "replyLang": "язык клиента: {{lang}}",
      "send": "Отправить",
      "you": "Вы",
      "client": "клиент",
      "provider": "исполнитель",
      "startHint": "Сообщений ещё нет — напишите первым, ответ придёт в чат с ботом.",
      "write": "Написать",
      "tab_all": "Все",
      "tab_clients": "Клиенты",
      "tab_providers": "Исполнители"
    },
    "partners": {
      "name": "Название",
      "category": "Категория",
      "offer": "Что по карте",
      "address": "Адрес",
      "summary": "предложений: {{offers}} · команда: {{members}} · проверок: {{visits}}",
      "manage": "Предложения и команда",
      "offers": "Предложения по уровням",
      "offerTitle": "Предложение",
      "minLevel": "Кому",
      "allMembers": "Все члены клуба",
      "limit": "Как часто",
      "limitCount": "Сколько раз",
      "limitKind_NONE": "Без ограничений",
      "limitKind_ONCE": "Только первое посещение",
      "limitKind_WEEK": "N раз в неделю",
      "limitKind_MONTH": "N раз в месяц",
      "limit_NONE": "без ограничений",
      "limit_ONCE": "только первый визит",
      "limit_WEEK": "{{count}}× в неделю",
      "limit_MONTH": "{{count}}× в месяц",
      "noOffers": "Предложений нет — клиенты увидят только описание партнёра.",
      "team": "Собственник и сотрудники",
      "ownerLink": "Ссылка для собственника",
      "ownerLinkHint": "Отправьте собственнику или дайте отсканировать: откроется рабочий бот, после Start он станет собственником и сможет приглашать сотрудников. Ссылка одноразовая.",
      "noTeam": "Пока никто не подключён.",
      "removeConfirm": "Отключить этого человека от партнёра?"
    },
    "requests": {
      "activate": "Включить на 30 дней",
      "activateConfirm": "Включить {{plan}} на 30 дней?",
      "client": "Клиент",
      "comment": "Комментарий",
      "empty": "Заявок нет.",
      "markDone": "Связались",
      "subscription": "Подписка {{plan}}",
      "what": "Что нужно",
      "status_NEW": "Новая",
      "status_DONE": "Готово",
      "status_CANCELLED": "Отменена"
    },
    "telegram": {
      "title": "Telegram: @{{bot}}",
      "linked": "подключён",
      "notLinked": "не подключён",
      "what": "Рабочий бот присылает вам:",
      "e1": "сообщения клиентов и исполнителей — ответить можно прямо в Telegram кнопкой «Ответить»",
      "e2": "заявки на переезд — с сайта и из приложения",
      "e3": "заявки из приложения — подписка и «перезвоните»",
      "e4": "новые заказы и заявки на уборку с сайта",
      "how": "Нажмите «Подключить» — откроется рабочий бот, нажмите в нём «Start». Так же подключается каждый оператор под своим входом.",
      "connect": "Подключить Telegram",
      "relink": "Подключить другой Telegram",
      "unlink": "Отключить",
      "notify": "Присылать уведомления"
    },
    "templates": {
      "STEP": "Шаги переезда",
      "STEP_hint": "Из них собирается план клиента: «под ключ» — отмеченные, конструктор — выбранные в квизе",
      "DOC": "Документы",
      "DOC_hint": "Чек-лист, который получает каждый новый клиент",
      "sub": "Изменения действуют для новых клиентов. У конкретного клиента шаги и документы меняются в разделе «Переезд».",
      "name": "Название",
      "hintField": "Подсказка",
      "active": "Показывать новым клиентам",
      "inTurnkey": "Входит в «под ключ»",
      "turnkey": "под ключ",
      "hidden": "скрыт",
      "missing": "нет перевода: {{langs}}"
    }
  },
  "landing": {
    "meta": {
      "title": "Barev Club — Ереван как дома. С первого дня",
      "description": "Клининг, документы, обучение и скидки партнёров для тех, кто переехал в Ереван. Всё внутри Telegram, на 5 языках."
    },
    "nav": {
      "label": "Разделы",
      "services": "Услуги",
      "how": "Как это работает",
      "plans": "Членство",
      "faq": "Вопросы"
    },
    "openTelegram": "Открыть в Telegram",
    "hero": {
      "tag": "Для тех, кто переехал в Ереван",
      "title": "Ереван — как дома. С первого дня.",
      "sub": "Быт, документы, обучение и скидки партнёров — в одном клубе в Telegram.",
      "cta": "Вступить бесплатно",
      "services": "Смотреть услуги",
      "cleanTitle": "Уборка квартиры от {{price}}",
      "cleanText": "Посчитай цену и выбери время за минуту, без звонков.",
      "cleanCta": "Посчитать уборку"
    },
    "preview": {
      "title": "Мои заявки",
      "inApp": "в приложении",
      "cleaning": "Клининг · генеральная",
      "cleaningMeta": "Сб 16:00",
      "inWork": "В работе",
      "lesson": "Армянский A1 · урок 3",
      "lessonMeta": "Сегодня 15:00 · онлайн",
      "today": "Сегодня",
      "cleaningRegular": "Клининг · обычная",
      "cleaningRegularMeta": "Сегодня 12:30"
    },
    "languages": "языков",
    "noInstall": "Без установки",
    "noInstallSub": "Всё внутри Telegram",
    "dir": {
      "HOME": "Проверенные исполнители, статус заказа в приложении.",
      "HOME_cta": "Заказать",
      "DOCS": "Нотариальный перевод и сопровождение до готового документа.",
      "DOCS_cta": "Оформить",
      "LEARNING": "Онлайн и офлайн, в удобное время.",
      "LEARNING_cta": "Записаться",
      "soonCta": "Узнать о запуске"
    },
    "perks": {
      "upTo": "до −{{pct}}%",
      "cafes": "Кофейни",
      "restaurants": "Рестораны",
      "gifts": "Подарки партнёров",
      "text": "Покажи клубную карту в Telegram на кассе.",
      "cta": "Смотреть партнёров"
    },
    "how": {
      "titleBold": "Как это",
      "titleItalic": "работает",
      "step1": "Отсканируй QR",
      "step1_sub": "Из договора аренды или с сайта",
      "step2": "Выбери язык",
      "step2_sub": "Пять языков на выбор",
      "step3": "Закажи услугу",
      "step3_sub": "Время, адрес, оплата",
      "step4": "Следи за статусом",
      "step4_sub": "Чат с исполнителем внутри"
    },
    "agency": {
      "title": "Сняли квартиру через риэлторское агентство-партнёр?",
      "text": "Код на месяц Barev+ уже в договоре.",
      "gift": "Подарок!",
      "giftSub": "1 месяц Barev+"
    },
    "plans": {
      "tryPlus": "Попробовать Barev+"
    },
    "faq": {
      "install": {
        "q": "Нужно что-то устанавливать?",
        "a": "Нет. Клуб работает внутри Telegram: открываешь бота и пользуешься."
      },
      "languages": {
        "q": "На каких языках можно общаться?",
        "a": "Русский, английский, китайский, армянский и испанский."
      },
      "plus": {
        "q": "Чем Barev+ отличается от бесплатного?",
        "a": "Скидки до {{pct}}% на документы, быт, обучение и карьерные консультации."
      },
      "gift": {
        "q": "Как получить подарок от риэлторского агентства?",
        "a": "Код указан в договоре аренды. Введи его в боте — и {{days}} дней Barev+ твои."
      }
    },
    "footer": {
      "brand": "Barev Club · Ереван",
      "partner": "Стать партнёром",
      "privacy": "Политика конфиденциальности",
      "legal": "ИП Забудько Юрий Константинович · ՀՎՀՀ {{tin}}",
      "services": "Услуги",
      "pricing": "Цены",
      "terms": "Условия использования",
      "refund": "Отмена и возврат",
      "rules": "Правила сервиса"
    },
    "clean": {
      "meta": {
        "title": "Уборка квартиры в Ереване — Barev Club",
        "description": "Поддерживающая, генеральная и после ремонта. Цена сразу, время выбираешь сам, статус заказа — в Telegram."
      },
      "home": "Главная",
      "title": "Уборка квартиры в Ереване",
      "sub": "Посчитай цену и выбери время. Заявку подтвердим в Telegram и пришлём клинера.",
      "duration": "Примерно {{hours}} ч работы",
      "extrasTitle": "Добавить к уборке",
      "extrasHint": "Всё, что нужно сделать сверх стандартной уборки.",
      "whenTitle": "Когда приехать",
      "whenHint": "Это желаемое время — точное подтвердим в Telegram.",
      "noTimes": "На этот день время уже не выбрать — посмотри следующий.",
      "addressTitle": "Адрес",
      "district": "Район",
      "districtPlaceholder": "Выбери район",
      "street": "Улица, дом, квартира",
      "streetPlaceholder": "Например, Пушкина 10, кв. 5",
      "note": "Комментарий для клинера",
      "notePlaceholder": "Код домофона, питомцы, где ключи",
      "contactTitle": "Контакты",
      "phone": "Телефон",
      "phoneHint": "Позвоним, только если не получится связаться в Telegram.",
      "name": "Как к тебе обращаться",
      "consent": "Согласен на обработку персональных данных",
      "privacy": "Политика конфиденциальности",
      "summaryTitle": "Твоя уборка",
      "total": "Итого",
      "plusHint": "С Barev+ — скидка {{pct}}% на уборку",
      "submit": "Отправить заявку",
      "sending": "Отправляем…",
      "after": "После отправки откроется Telegram: там подтвердим время и покажем статус.",
      "err": {
        "time": "Выбери время.",
        "district": "Выбери район.",
        "street": "Укажи улицу и дом.",
        "phone": "Укажи телефон с кодом страны, например +374 91 123456.",
        "consent": "Без согласия мы не сможем принять заявку.",
        "network": "Не получилось отправить. Проверь интернет и попробуй ещё раз."
      },
      "doneTitle": "Заявка №{{number}} принята",
      "doneText": "Сейчас откроется Telegram — бот подтвердит заявку и покажет статус. Если ничего не произошло, нажми кнопку.",
      "doneCta": "Открыть Telegram",
      "doneAgain": "Оформить ещё одну",
      "includedTitle": "Что входит в уборку",
      "zone": {
        "kitchen": "Кухня",
        "bathroom": "Санузел",
        "rooms": "Комнаты"
      },
      "inc": {
        "kitchen": "Моем раковину и смеситель\nПротираем плиту, столешницу и фартук\nПротираем фасады шкафов и технику снаружи\nМоем пол и выносим мусор",
        "bathroom": "Моем ванну или душ, раковину и унитаз\nЧистим зеркала и смесители\nПротираем полки и двери\nМоем пол",
        "rooms": "Протираем пыль на доступных поверхностях\nПылесосим и моем пол\nЗаправляем кровать, раскладываем вещи\nПротираем зеркала и выключатели"
      },
      "general": "Генеральная — всё это плюс труднодоступные места: за мебелью, плинтусы, двери, батареи и внутри шкафов.",
      "renovation": "После ремонта — ещё строительная пыль, следы краски, клея и цемента со всех поверхностей.",
      "howTitle": "Как это работает",
      "how1": "Оставляешь заявку здесь",
      "how1Sub": "Цена видна сразу, без звонков",
      "how2": "Подтверждаем в Telegram",
      "how2Sub": "Бот покажет заказ и его статус",
      "how3": "Приезжает клинер",
      "how3Sub": "Работает по чек-листу, присылает фотоотчёт",
      "whenHintOptional": "Необязательно: если не выберете, бот спросит в Telegram.",
      "addressHintOptional": "Необязательно: адрес можно написать боту после отправки.",
      "nameTitle": "Как к вам обращаться",
      "consentByClick": "Нажимая кнопку, вы соглашаетесь на обработку персональных данных."
    },
    "v1": {
      "title": "Всё для жизни в Ереване — в одном чате",
      "sub": "Barev Club — бот в Telegram. Пишешь, что нужно, сразу видишь цену и выбираешь время. Остальное делаем мы.",
      "botName": "Barev Club",
      "botStatus": "бот, отвечает сразу",
      "u1": "Привет! Нужна уборка в субботу, 2 комнаты",
      "b1": "Привет! Обычная уборка, 2 комнаты и санузел — {{price}}. Суббота, 11:00 подойдёт?",
      "u2": "Да, отлично",
      "b2": "Готово. Клинер приедет в 11:00 — статус и фотоотчёт пришлю сюда.",
      "canTitle": "Что можно заказать",
      "canText": "Уборка уже работает. Остальное запускаем по очереди — бот напишет, когда откроется.",
      "whyTitle": "Почему в Telegram",
      "why1": "Ничего не нужно ставить",
      "why1Sub": "Бот и приложение открываются прямо в Telegram.",
      "why2": "Пять языков",
      "why2Sub": "Русский, английский, китайский, армянский и испанский.",
      "why3": "Всё в одной переписке",
      "why3Sub": "Статус, чат с исполнителем и фотоотчёт — там же, где ты общаешься.",
      "ctaTitle": "Начни с «Barev»",
      "ctaText": "Так по-армянски говорят «привет». Напиши боту — он ответит на твоём языке.",
      "cta": "Написать боту"
    },
    "v2": {
      "hello": "Привет\nHello\n你好\nԲարև\nHola",
      "title": "Переезд в Ереван — по шагам",
      "sub": "От аэропорта до своей квартиры и документов. Клуб рядом на каждом шаге, а все вопросы решаются в одном чате.",
      "calc": "Посчитать",
      "ctaTitle": "Клуб бесплатный",
      "ctaText": "Вступи в Telegram — все шаги будут под рукой, на твоём языке.",
      "cta": "Вступить в клуб",
      "whenArrive": "Прилёт",
      "whenWeek": "Первая неделя",
      "whenSettled": "После заселения",
      "whenLater": "Дальше",
      "whenDaily": "Каждый день",
      "whenAnytime": "В любой момент",
      "airportTitle": "Встретим в аэропорту и заселим в отель",
      "airportText": "Водитель с табличкой в Звартноце и трансфер до отеля — первые дни без забот.",
      "flatTitle": "Найдём квартиру",
      "flatText": "Подберём жильё через риэлторские агентства-партнёры, а перед заездом сделаем уборку.",
      "docsTitle": "Сделаем регистрацию и соцкарту",
      "docsText": "Подготовим документы, запишем и проводим до готовой карты.",
      "permitTitle": "Поможем с документами на ВНЖ",
      "permitText": "Соберём пакет, переведём и заверим, подскажем сроки и порядок подачи.",
      "perksTitle": "Пользуйся скидками и привилегиями клуба",
      "perksText": "Кафе, рестораны и подарки партнёров по клубной карте, а с Barev+ — ещё и скидки на услуги.",
      "chatTitle": "Любой вопрос — в чат",
      "chatText": "Сломался кран или просрочил пребывание в Армении — пиши «помогите!», разберёмся и подскажем, что делать.",
      "chatChip": "в Telegram",
      "chatCta": "Написать в чат"
    },
    "v3": {
      "tag": "Для арендаторов риэлторских агентств-партнёров",
      "title": "Добро пожаловать домой",
      "sub": "Риэлторское агентство, через которое ты снял квартиру, дарит подписку Barev+ — скидки на уборку, документы и уроки.",
      "giftTitle": "1 месяц Barev+",
      "giftCode": "Код {{code}} применится сам",
      "giftNoCode": "Код — в договоре аренды",
      "stepsTitle": "Как получить",
      "step1": "Нажми «Получить подарок»",
      "step1Sub": "Откроется бот Barev Club в Telegram.",
      "step2": "Выбери язык и подтверди согласие",
      "step2Sub": "Это займёт десять секунд.",
      "step3": "Подарок включится сам",
      "step3Sub": "Скидки сразу применяются к заказам.",
      "benefitsTitle": "Что даёт месяц Barev+",
      "cleaningDeal": "Уборка от {{price}} вместо {{full}}",
      "cleaningDealSub": "Поддерживающая уборка, скидка уже в цене.",
      "cta": "Получить подарок",
      "noCode": "Нет кода? Отправь его боту командой /code — или вступай без него: клуб бесплатный."
    },
    "v4": {
      "title": "Прилетел в Ереван? Дальше — мы",
      "sub": "Уборка, документы и уроки армянского — заказываешь в Telegram на своём языке, как будто живёшь здесь давно.",
      "board": "Прилёт",
      "city": "Ереван",
      "colFlight": "Рейс",
      "colService": "Услуга",
      "colPrice": "Цена",
      "colStatus": "Статус",
      "live": "Работает",
      "soon": "Скоро",
      "passTitle": "Посадочный талон",
      "passenger": "Пассажир",
      "passengerValue": "Ты",
      "from": "Откуда",
      "fromValue": "Откуда угодно",
      "to": "Куда",
      "toValue": "Ереван, как дома",
      "gate": "Выход",
      "gateValue": "Telegram",
      "cta": "Пройти на посадку",
      "clean": "Сразу заказать уборку"
    },
    "v5": {
      "title": "Сколько сэкономишь с Barev+",
      "sub": "Посчитай честно: цена подписки уже вычтена из экономии.",
      "perMonth": "Уборок в месяц",
      "without": "Без Barev+",
      "with": "С Barev+",
      "withNote": "включая подписку {{price}}",
      "save": "Экономия в месяц",
      "noSave": "Пока выгоднее без подписки",
      "breakeven": "Barev+ окупается с {{count}} уборок в месяц такого размера.",
      "breakevenFirst": "Barev+ окупается с первой уборки такого размера.",
      "perYear": "За год — {{amount}}",
      "other": "Подписка действует и на другие направления",
      "cta": "Попробовать Barev+",
      "gift": "Снял квартиру через риэлторское агентство-партнёр? Подписка — в подарок."
    },
    "v6": {
      "tag": "Для риэлторских агентств",
      "title": "Договор о том, как ваши арендаторы обживаются в Ереване",
      "sub": "Вы дарите клиентам месяц Barev+, мы помогаем им с бытом, а вы получаете процент с их заказов.",
      "docDate": "Ереван",
      "s1": "Что получает риэлторское агентство",
      "s1i1": "{{pct}}% с каждого заказа клиента в течение {{months}} месяцев после первого входа в бота.",
      "s1i2": "Свой код и QR — их можно вставить в договор аренды или передать вместе с ключами.",
      "s1i3": "Отчёт по клиентам и заказам: сколько пришло, сколько заказало и сколько вы заработали.",
      "s2": "Что получает арендатор",
      "s2i1": "Barev+ на {{days}} дней в подарок — скидки на уборку, документы и уроки.",
      "s2i2": "Сервис на пяти языках внутри Telegram — без приложений и звонков.",
      "s2i3": "Проверенные исполнители и статус каждого заказа.",
      "s3": "Как подключиться",
      "s3i1": "Напишите нам в бота — ответим в течение дня.",
      "s3i2": "Получите код агентства и QR.",
      "s3i3": "Добавьте QR в договор аренды. Всё остальное мы берём на себя.",
      "exampleTitle": "Пример",
      "exampleText": "{{clients}} клиентов × {{orders}} уборки в месяц × {{price}}",
      "exampleResult": "{{amount}} агентству в месяц",
      "exampleNote": "Расчёт по обычной уборке квартиры с двумя комнатами.",
      "signAgency": "Риэлторское агентство",
      "signUs": "Barev Club",
      "cta": "Стать партнёром"
    },
    "home": {
      "metaTitle": "Переезд в Армению под ключ: жильё, соцкарта, ВНЖ — Barev Club",
      "metaDescription": "Встретим в аэропорту Звартноц, найдём квартиру в Ереване, сделаем соцкарту за 1 день, регистрацию и документы на ВНЖ. Один чат в Telegram на 5 языках.",
      "switchLabel": "Для кого страница",
      "switchMove": "Переезжаю",
      "switchLive": "Уже живу в Армении",
      "title": "Переезд в Армению — по шагам",
      "sub": "Встретим в аэропорту, найдём квартиру и сделаем документы. Все вопросы решаются в одном чате, на вашем языке.",
      "cta": "Подобрать переезд",
      "ctaChat": "Написать в Telegram",
      "whenArrive": "Прилёт",
      "whenFirst": "Первые дни",
      "whenSettled": "После заселения",
      "whenLater": "Дальше",
      "whenDaily": "Каждый день",
      "whenAnytime": "В любой момент",
      "airportTitle": "Встретим в аэропорту и заселим в отель",
      "airportText": "Водитель с табличкой в Звартноце, трансфер и номер в отеле — первые дни без забот.",
      "flatTitle": "Найдём квартиру",
      "flatText": "Подберём варианты за 1 день, просмотры назначим на следующий.",
      "docsTitle": "Сделаем регистрацию и соцкарту",
      "docsText": "Подготовим документы и проводим до готовой карты. Соцкарта — на следующий день.",
      "permitTitle": "Поможем с документами на ВНЖ",
      "permitText": "Через трудоустройство: соберём пакет, переведём и заверим, подскажем сроки подачи.",
      "perksTitle": "Пользуйтесь скидками и привилегиями клуба",
      "perksText": "Скидки на услуги и подарки от партнёров по подписке Barev+ и Barev Elite.",
      "chatTitle": "Любой вопрос — в чат",
      "chatText": "Сломался кран или просрочили пребывание в Армении — напишите «помогите!», разберёмся и подскажем, что делать.",
      "chatCta": "Написать в чат",
      "finalTitle": "Расскажите о переезде",
      "finalText": "Несколько вопросов — и мы соберём план переезда и посчитаем цену.",
      "more": "Подробнее",
      "perksSoon": "Скоро"
    },
    "live": {
      "metaTitle": "Скидки на услуги в Ереване по подписке — Barev Club",
      "metaDescription": "Подписка клуба: скидки до −{{pct}}% на клининг, ремонт, трансфер, экскурсии и документы, языки и карьерные консультации, подарки от партнёров.",
      "title": "Живёте в Армении? С клубом дешевле",
      "sub": "Оформите подписку и получайте скидки на услуги, которые нужны каждый месяц.",
      "cta": "Оформить подписку",
      "ctaPlans": "Сравнить тарифы",
      "listTitle": "На что действуют скидки",
      "listNote": "Максимальная скидка — с Barev Elite. С Barev+ — до −{{pct}}%.",
      "upTo": "до −{{pct}}%",
      "discount": "скидка",
      "gifts": "подарки",
      "cleaning": "Клининг",
      "cleaningHint": "регулярная, генеральная, после ремонта",
      "repair": "Ремонт",
      "repairHint": "сантехник, электрик, мелкий ремонт",
      "transfer": "Трансфер",
      "transferHint": "из аэропорта и в аэропорт",
      "tours": "Экскурсии",
      "toursHint": "Гарни, Гегард, Севан и не только",
      "docs": "Документы",
      "docsHint": "соцкарта, ВНЖ, регистрация, оформление ИП и ООО",
      "lang": "Языки",
      "langHint": "английский и армянский",
      "career": "Карьера",
      "careerHint": "резюме, профиль в LinkedIn, подготовка к собеседованию",
      "partners": "Партнёры",
      "partnersHint": "кафе, рестораны и магазины клуба",
      "finalTitle": "Подписка оформляется в Telegram",
      "finalText": "Откройте бота клуба, выберите тариф — скидки появятся в ценах услуг.",
      "orderNow": "Заказать сейчас",
      "docsFrom": "от {{price}} с подпиской"
    },
    "club": {
      "title": "Подписка клуба",
      "sub": "Заказывать услуги можно бесплатно. Скидки и консьерж — по подписке.",
      "free": "бесплатно",
      "perMonth": "{{price}}/мес",
      "freeF1": "Заказ услуг и статусы в Telegram-боте",
      "freeF2": "Оплата и чат по каждой заявке",
      "freeF3": "Обычные цены на услуги",
      "plusF1": "Скидки на услуги до −{{pct}}%",
      "plusF2": "Подарки от партнёров",
      "plusF3": "Консьерж в чате по будням с 10 до 18",
      "eliteF1": "Скидки на услуги до −{{pct}}%",
      "eliteF2": "Подарки от партнёров",
      "eliteF3": "Консьерж в чате 24/7 — решаем любые вопросы",
      "freeCta": "Открыть бота",
      "plusCta": "Оформить Barev+",
      "eliteCta": "Оформить Elite"
    },
    "quiz": {
      "dialog": "Подбор переезда",
      "close": "Закрыть",
      "back": "Назад",
      "next": "Дальше",
      "progress": "Шаг {{n}} из {{total}}",
      "sending": "Сохраняем…",
      "contactTitle": "Как к вам обращаться?",
      "name": "Имя",
      "contact": "Телефон или Telegram",
      "contactHint": "+374 … или @username",
      "consentPre": "Нажимая «Дальше», вы соглашаетесь с ",
      "consentLink": "политикой конфиденциальности",
      "errName": "Напишите, как к вам обращаться.",
      "errContact": "Нужен телефон (+374…) или ник в Telegram (@username).",
      "movedTitle": "Вы уже переехали в Армению?",
      "movedYes": "Да, уже живу здесь",
      "movedNo": "Нет, только планирую",
      "movingToLive": "Открываем страницу для тех, кто уже живёт в Армении…",
      "whenTitle": "Когда планируете переезд?",
      "when_month": "В ближайший месяц",
      "when_quarter": "Через 1–3 месяца",
      "when_later": "Позже, пока присматриваюсь",
      "when_date": "Знаю точную дату",
      "date": "Дата прилёта",
      "errWhen": "Выберите вариант или укажите дату.",
      "packageTitle": "Какой пакет услуг нужен?",
      "package_CONSULT": "Только консультация",
      "package_CONSULT_text": "Разберём ваш случай и составим план переезда.",
      "package_TURNKEY": "Под ключ",
      "package_TURNKEY_text": "От встречи в аэропорту до ВНЖ или регистрации. Точную цену посчитаем по заявке.",
      "package_TURNKEY_price": "по расчёту",
      "package_CUSTOM": "Соберу сам",
      "package_CUSTOM_text": "Отметьте только нужные услуги.",
      "customTitle": "Соберите свой пакет",
      "airport": "Встреча в аэропорту",
      "airport_none": "Не нужна",
      "airport_standard": "Стандарт",
      "airport_premium": "Премиум",
      "stay": "Жильё на первое время",
      "stay_none": "Не нужно",
      "stay_flat": "Квартира",
      "stay_hotel": "Отель",
      "budget": "Бюджет за сутки, ֏",
      "budgetFrom": "от",
      "budgetTo": "до",
      "flat": "Поиск квартиры",
      "socialCard": "Соцкарта",
      "bankCard": "Банковская карта",
      "registration": "Регистрация",
      "residence": "ВНЖ",
      "no": "Нет",
      "yes": "Да",
      "yesHint": "Свяжемся и уточним детали",
      "errEmpty": "Отметьте хотя бы одну услугу.",
      "submit": "Отправить заявку",
      "doneTitle": "Заявка №{{number}} принята",
      "doneText": "Свяжемся с вами в течение дня: {{contact}}.",
      "doneBot": "Открыть клуб в Telegram",
      "doneClose": "Вернуться на сайт",
      "errNetwork": "Нет связи с сервером. Проверьте интернет и попробуйте ещё раз."
    },
    "seo": {
      "org": "Barev Club — клуб-сервис для тех, кто переезжает в Ереван или уже живёт в Армении: встреча в аэропорту, жильё, соцкарта, ВНЖ, уборка и скидки партнёров. Всё в Telegram на 5 языках."
    },
    "svc": {
      "common": {
        "home": "Главная",
        "updated": "Обновлено 20 октября 2026",
        "factsTitle": "Коротко",
        "pricesTitle": "Цены",
        "faqTitle": "Частые вопросы",
        "relatedTitle": "Ещё по переезду",
        "cta": "Написать в Telegram",
        "ctaMove": "Весь переезд под ключ",
        "clean": "Уборка квартиры",
        "breadcrumbs": "Навигация"
      },
      "socialCard": {
        "meta": {
          "title": "Соцкарта в Армении для иностранцев: документы, сроки, цена — Barev Club",
          "description": "Как получить соцкарту (ՀԾՀ) в Армении в 2026 году: какие документы нужны, куда идти и сколько ждать. Сделаем под ключ за {{price}}, обычно за 1 день."
        },
        "crumb": "Соцкарта",
        "h1": "Соцкарта в Армении: как получить за 1 день",
        "lead": "Соцкарта — это номер социальных услуг (ՀԾՀ) из 10 цифр. Без него в Армении не открыть счёт в банке, не зарегистрировать ИП и не подать на ВНЖ. Иностранцу номер выдают в отделе Миграционной службы, обычно в день обращения. Barev Club сделает всё под ключ за {{price}}: перевод паспорта, запись и сопровождение.",
        "priceLabel": "Под ключ",
        "priceValue": "{{price}}",
        "priceNote": "перевод паспорта, нотариус, запись и сопровождение",
        "facts": {
          "f1": {
            "label": "Срок",
            "value": "обычно 1 день"
          },
          "f2": {
            "label": "Цена",
            "value": "{{price}} под ключ"
          },
          "f3": {
            "label": "Где выдают",
            "value": "отдел Миграционной службы МВД"
          },
          "f4": {
            "label": "Что нужно от вас",
            "value": "паспорт со штампом въезда"
          }
        },
        "stepsTitle": "Как это проходит с нами",
        "steps": {
          "s1": {
            "when": "День 1",
            "title": "Пишете в Telegram",
            "text": "Присылаете фото паспорта и адрес в Ереване. Подойдёт адрес съёмной квартиры или отеля."
          },
          "s2": {
            "when": "День 1",
            "title": "Делаем нотариальный перевод",
            "text": "Переводим главную страницу паспорта на армянский и заверяем у нотариуса."
          },
          "s3": {
            "when": "День 1",
            "title": "Записываем в отдел",
            "text": "Выбираем отдел с короткой очередью и удобное вам время."
          },
          "s4": {
            "when": "День 1–2",
            "title": "Идём вместе",
            "text": "Сопровождающий говорит по-армянски и заполняет заявление. Вам нужно только прийти с паспортом."
          },
          "s5": {
            "when": "День 1–2",
            "title": "Получаете номер",
            "text": "Справку с номером обычно выдают сразу, иногда — на следующий день."
          }
        },
        "blocks": {
          "b1": {
            "title": "Что такое соцкарта",
            "body": "Соцкарта — разговорное название номера социальных услуг (ՀԾՀ, Public Services Number). Это уникальный 10-значный номер, который государство присваивает гражданам Армении и иностранцам, законно находящимся в стране.\nИностранцам выдают не пластиковую карту, а справку с номером. Если у вас уже есть ВНЖ, номер может быть указан в карте резидента."
          },
          "b2": {
            "title": "Зачем она нужна",
            "body": "• открыть счёт и карту в армянском банке;\n• зарегистрировать ИП или ООО;\n• платить налоги и получать зарплату официально;\n• подать документы на ВНЖ;\n• записаться к врачу в государственную поликлинику;\n• купить машину и получить армянские права."
          },
          "b3": {
            "title": "Какие документы нужны",
            "body": "• Паспорт со штампом о въезде в Армению.\n• Нотариальный перевод главной страницы паспорта на армянский — его делаем мы.\n• Адрес в Армении: подойдёт съёмная квартира или отель, регистрация по нему не нужна.\n• Если вы въехали по внутреннему паспорту РФ, понадобится и его нотариальный перевод. Это может добавить несколько дней.\nИногда отдел просит свидетельство о рождении или документ о регистрации. Если понадобится, скажем заранее."
          },
          "b4": {
            "title": "Что меняется с 1 ноября 2026",
            "body": "С 1 ноября 2026 года в Армении вступает в силу новый закон об иностранцах и меняется система записи в Миграционную службу. Мы следим за изменениями и запишем вас по актуальным правилам."
          }
        },
        "prices": {
          "p1": {
            "name": "Соцкарта под ключ",
            "value": "{{price}}",
            "note": "перевод паспорта, нотариус, запись, сопровождение"
          },
          "p2": {
            "name": "С подпиской Barev+",
            "value": "−{{docsPct}}%",
            "note": "скидка на все услуги по документам"
          }
        },
        "faq": {
          "q1": {
            "q": "Можно ли получить соцкарту без ВНЖ?",
            "a": "Да. Номер выдают иностранцам, которые законно находятся в Армении, например по штампу о въезде. ВНЖ для этого не нужен."
          },
          "q2": {
            "q": "Сколько времени занимает оформление соцкарты?",
            "a": "Чаще всего справку выдают в день обращения, в некоторых отделах — на следующий день. Нотариальный перевод паспорта мы делаем заранее, поэтому обычно на всё уходит 1–2 дня."
          },
          "q3": {
            "q": "Нужно ли знать армянский язык?",
            "a": "Нет. С вами пойдёт сопровождающий, который говорит по-армянски и по-русски, и заполнит заявление за вас."
          },
          "q4": {
            "q": "Можно ли получить соцкарту без личного визита?",
            "a": "Справку может получить представитель по доверенности, а при наличии армянской электронной подписи — онлайн. Если вас нет в Ереване, напишите нам: подберём вариант."
          },
          "q5": {
            "q": "Чем соцкарта отличается от налогового номера (ՀՎՀՀ)?",
            "a": "Соцкарта (ՀԾՀ) — личный номер человека. ՀՎՀՀ — налоговый номер, который получают ИП и компании. Чтобы открыть ИП, сначала нужна соцкарта."
          }
        },
        "finalTitle": "Нужна соцкарта?",
        "finalText": "Напишите в Telegram — запишем на ближайший удобный день и сделаем перевод паспорта."
      },
      "residence": {
        "meta": {
          "title": "ВНЖ Армении в 2026: новые правила с 1 ноября, основания, цена — Barev Club",
          "description": "Как получить вид на жительство в Армении по новому закону: работа, ИП, ООО, семья. Пошлина {{fee}}, подача онлайн. Консультация {{consult}}, сопровождение от {{escort}}."
        },
        "crumb": "ВНЖ",
        "h1": "ВНЖ Армении в 2026 году: что изменилось и как получить",
        "lead": "С 1 ноября 2026 года в Армении действует новый закон об иностранцах. Заявление на ВНЖ подают онлайн, сначала выдают ВНЖ на 1 год, а госпошлина выросла до {{fee}}. Основания — работа, ИП, ООО, учёба или семья. Barev Club подберёт основание и проведёт вас до получения карты резидента.",
        "priceLabel": "Сопровождение",
        "priceValue": "от {{escort}}",
        "priceNote": "+ госпошлина {{fee}}. Консультация {{consult}} засчитывается",
        "facts": {
          "f1": {
            "label": "Новые правила",
            "value": "с 1 ноября 2026"
          },
          "f2": {
            "label": "Госпошлина",
            "value": "{{fee}} за 1 год"
          },
          "f3": {
            "label": "Подача",
            "value": "онлайн + один визит для отпечатков"
          },
          "f4": {
            "label": "Сопровождение",
            "value": "от {{escort}}"
          }
        },
        "stepsTitle": "Как мы ведём ВНЖ",
        "steps": {
          "s1": {
            "when": "Неделя 1",
            "title": "Консультация",
            "text": "Разбираем ваш случай и выбираем основание: работа, ИП, ООО или семья. Консультация {{consult}} засчитывается в сопровождение."
          },
          "s2": {
            "when": "Неделя 1–2",
            "title": "Готовим основание",
            "text": "Помогаем открыть ИП или ООО, внести нужную сумму или оформить трудовой договор."
          },
          "s3": {
            "when": "Неделя 2–3",
            "title": "Собираем документы",
            "text": "Переводим и заверяем документы, оформляем соцкарту, если её ещё нет."
          },
          "s4": {
            "when": "Подача",
            "title": "Подаём заявление онлайн",
            "text": "Заполняем заявку на государственном портале и отвечаем на запросы Миграционной службы."
          },
          "s5": {
            "when": "Визит",
            "title": "Сдаёте отпечатки пальцев",
            "text": "Один раз нужно лично прийти в Миграционную службу: сдать отпечатки и подписать заявление. Идём вместе."
          },
          "s6": {
            "when": "Готово",
            "title": "Получаете карту резидента",
            "text": "Сообщаем о решении и помогаем забрать карту."
          }
        },
        "blocks": {
          "b1": {
            "title": "Что изменилось с 1 ноября 2026",
            "body": "• Новую редакцию закона «Об иностранцах» приняли 20 января 2026 года, она действует с 1 ноября 2026.\n• Заявление подают онлайн через единый портал. Лично нужно прийти один раз — сдать отпечатки пальцев и подписать заявление. Доверенность этого не заменяет.\n• Сначала выдают ВНЖ на 1 год. Постоянный ВНЖ на 5 лет — после 3 лет временного ВНЖ из последних 5.\n• Госпошлина за ВНЖ на 1 год — 150 000 ֏ и 5 950 ֏ за карту, за постоянный ВНЖ — 255 950 ֏.\n• Правительство вводит ежегодные квоты. Когда квота заканчивается, новые заявления не принимают.\n• Специальный 10-летний статус для этнических армян больше не выдают. Выданные документы действуют до конца срока.\n• Заявления, поданные до 1 ноября, рассматривают по старым правилам. Выданные ВНЖ действуют до даты на карте, новые правила применяются при продлении."
          },
          "b2": {
            "title": "Основания для ВНЖ",
            "body": "• Работа: трудовой договор с армянской компанией. Проверку рынка труда отменили, вместо неё действует квота.\n• ИП: 1 000 000 ֏ на счёте в армянском банке при подаче или такой же оборот за 60 дней до подачи.\n• ООО: вклад в уставный капитал или покупка доли от 2 000 000 ֏. Если 180 дней после одобрения нет налоговых начислений, ВНЖ могут аннулировать.\n• Учёба: подходят не только вузы, но и курсы, профессиональное обучение и программы обмена.\n• Семья: супруг, родитель или ребёнок гражданина Армении или иностранца с ВНЖ.\nПокупка квартиры сама по себе права на ВНЖ не даёт."
          },
          "b3": {
            "title": "Какие документы понадобятся",
            "body": "• паспорт и его нотариальный перевод на армянский;\n• документ об основании: трудовой договор, выписка о регистрации ИП или ООО, справка из банка, свидетельство о браке или рождении;\n• соцкарта (номер социальных услуг);\n• квитанция об оплате госпошлины.\nТочный список утверждает правительство подзаконными актами. На консультации сверим его с актуальной версией."
          },
          "b4": {
            "title": "Можно ли жить в Армении без ВНЖ",
            "body": "Граждане России въезжают без визы и могут находиться в Армении до 180 дней за один въезд. Для граждан других стран правила свои. Если срок подходит к концу, а ВНЖ ещё нет, за просрочку грозит штраф. Напишите нам заранее — подскажем, что успеть сделать."
          },
          "b5": {
            "title": "Важно",
            "body": "Информация актуальна на 20 октября 2026 года. Часть правил уточняется подзаконными актами, поэтому перед каждой подачей мы сверяем требования с Миграционной службой. Этот текст не заменяет юридическую консультацию."
          }
        },
        "prices": {
          "p1": {
            "name": "Консультация",
            "value": "{{consult}}",
            "note": "засчитывается в сопровождение"
          },
          "p2": {
            "name": "Сопровождение до карты",
            "value": "от {{escort}}",
            "note": "основание, документы, подача, визит"
          },
          "p3": {
            "name": "Госпошлина за ВНЖ на 1 год",
            "value": "{{fee}}",
            "note": "платится государству, с 1 ноября 2026"
          },
          "p4": {
            "name": "Госпошлина за ВНЖ на 5 лет",
            "value": "255 950 ֏",
            "note": "после 3 лет временного ВНЖ"
          }
        },
        "faq": {
          "q1": {
            "q": "Сколько стоит ВНЖ в Армении в 2026 году?",
            "a": "Госпошлина за ВНЖ на 1 год с 1 ноября 2026 года — {{fee}}: 150 000 ֏ пошлина и 5 950 ֏ за карту. Если основание — ИП, нужен ещё 1 000 000 ֏ на счёте или такой же оборот за 60 дней. Сопровождение Barev Club — от {{escort}}."
          },
          "q2": {
            "q": "Сколько ждать решения по ВНЖ?",
            "a": "Официальные сроки по новой системе Миграционная служба пока не опубликовала. Реальный срок назовём на консультации, когда появятся первые решения по новым правилам."
          },
          "q3": {
            "q": "Можно ли получить ВНЖ Армении, купив квартиру?",
            "a": "Нет. По новому закону владение недвижимостью само по себе не даёт права на ВНЖ. Нужны работа, бизнес, учёба или семья."
          },
          "q4": {
            "q": "Нужно ли приезжать лично?",
            "a": "Да, один раз: сдать отпечатки пальцев и подписать заявление в Армении. Доверенность это не заменяет, остальное делается онлайн."
          },
          "q5": {
            "q": "Что будет с ВНЖ, который у меня уже есть?",
            "a": "Он действует до даты окончания на карте. При продлении применяются новые правила, новая пошлина и онлайн-подача."
          },
          "q6": {
            "q": "Можно ли сразу получить ВНЖ на 5 лет?",
            "a": "Обычно нет: сначала выдают ВНЖ на 1 год, а постоянный — после 3 лет временного ВНЖ за последние 5 лет. Исключения — этнические армяне, инвесторы и люди с особыми заслугами перед Арменией."
          }
        },
        "finalTitle": "Разберём ваш случай",
        "finalText": "Расскажите о себе в Telegram — подберём основание для ВНЖ и посчитаем полную стоимость."
      },
      "airport": {
        "meta": {
          "title": "Трансфер из аэропорта Звартноц в Ереван с встречей — Barev Club",
          "description": "Встретим в Звартноце с табличкой, поможем с багажом и довезём до дома или отеля в Ереване. Стандарт {{standard}}, Премиум {{premium}}. Следим за рейсом, 60 минут ожидания бесплатно."
        },
        "crumb": "Трансфер из аэропорта",
        "h1": "Трансфер из аэропорта Звартноц с встречей",
        "lead": "Водитель встретит вас в зале прилёта аэропорта Звартноц с табличкой, поможет с багажом и отвезёт по любому адресу в Ереване. Дорога до центра занимает 20–30 минут. «Стандарт» стоит {{standard}} за машину до 3 пассажиров, «Премиум» — {{premium}}. Мы следим за рейсом, первые 60 минут ожидания бесплатно.",
        "priceLabel": "Встреча «Стандарт»",
        "priceValue": "{{standard}}",
        "priceNote": "до 3 пассажиров, табличка, 60 минут ожидания",
        "facts": {
          "f1": {
            "label": "Где встречаем",
            "value": "в зале прилёта с табличкой"
          },
          "f2": {
            "label": "Дорога до центра",
            "value": "20–30 минут"
          },
          "f3": {
            "label": "«Стандарт»",
            "value": "{{standard}}"
          },
          "f4": {
            "label": "«Премиум»",
            "value": "{{premium}}"
          }
        },
        "stepsTitle": "Как проходит встреча",
        "steps": {
          "s1": {
            "when": "До вылета",
            "title": "Присылаете номер рейса",
            "text": "Пишете в Telegram номер рейса, число пассажиров и чемоданов, адрес в Ереване."
          },
          "s2": {
            "when": "До вылета",
            "title": "Получаете данные водителя",
            "text": "Присылаем имя водителя, номер машины и чат с ним в боте."
          },
          "s3": {
            "when": "Прилёт",
            "title": "Следим за рейсом",
            "text": "Если рейс задерживается, водитель приедет к новому времени. Доплачивать не нужно."
          },
          "s4": {
            "when": "Прилёт",
            "title": "Встреча с табличкой",
            "text": "Водитель ждёт в зале прилёта с табличкой с вашим именем и помогает с багажом."
          },
          "s5": {
            "when": "Через 30 минут",
            "title": "Вы на месте",
            "text": "Довозим до квартиры или отеля в Ереване."
          }
        },
        "blocks": {
          "b1": {
            "title": "Что входит",
            "body": "• встреча в зале прилёта с табличкой;\n• помощь с багажом;\n• до 3 пассажиров в «Стандарте»;\n• отслеживание рейса;\n• 60 минут бесплатного ожидания после посадки;\n• чат с водителем через бота.\n«Премиум» добавляет автомобиль бизнес-класса, воду в машине и SIM-карту армянского оператора, чтобы связь была сразу после прилёта."
          },
          "b2": {
            "title": "Отель на первые дни",
            "body": "Если квартиры ещё нет, забронируем отель и довезём прямо туда. С подпиской Barev+ — от {{hotelPlus}} за сутки, без подписки — от {{hotelBase}}."
          },
          "b3": {
            "title": "Как ещё добраться из Звартноца",
            "body": "• Такси со стойки в аэропорту: по данным путеводителей, обычно 3 000–7 000 ֏ до центра, но без встречи в зале прилёта.\n• Приложения такси, например Yandex Go: недорого, но машину нужно найти на парковке самому.\n• Трансфер со встречей дороже, зато водитель ждёт в зале прилёта, следит за рейсом и помогает с багажом. Удобно, если вы летите с семьёй, поздно вечером или впервые в Армении."
          }
        },
        "prices": {
          "p1": {
            "name": "«Стандарт»",
            "value": "{{standard}}",
            "note": "до 3 пассажиров, табличка, 60 минут ожидания"
          },
          "p2": {
            "name": "«Премиум»",
            "value": "{{premium}}",
            "note": "бизнес-класс, вода, SIM-карта"
          },
          "p3": {
            "name": "Отель с Barev+",
            "value": "от {{hotelPlus}}",
            "note": "за сутки; без подписки — от {{hotelBase}}"
          },
          "p4": {
            "name": "С подпиской Barev+",
            "value": "−{{homePct}}%",
            "note": "на трансфер и бытовые услуги"
          }
        },
        "faq": {
          "q1": {
            "q": "Сколько стоит трансфер из аэропорта Звартноц в центр Еревана?",
            "a": "С Barev Club — {{standard}} за машину до 3 пассажиров со встречей и табличкой, «Премиум» — {{premium}}. Такси со стойки в аэропорту обычно стоит 3 000–7 000 ֏, но без встречи в зале прилёта."
          },
          "q2": {
            "q": "Что будет, если рейс задержится?",
            "a": "Мы следим за рейсом, и водитель приедет к фактическому времени посадки. Первые 60 минут после посадки ожидание бесплатно."
          },
          "q3": {
            "q": "Сколько ехать из аэропорта до центра Еревана?",
            "a": "Около 20–30 минут без пробок: аэропорт Звартноц находится примерно в 12 км к западу от центра."
          },
          "q4": {
            "q": "Можно ли заказать трансфер в аэропорт?",
            "a": "Да. Отвезём в Звартноц из любого адреса в Ереване по той же цене."
          },
          "q5": {
            "q": "Как заказать встречу?",
            "a": "Напишите в Telegram номер рейса, число пассажиров и адрес. Лучше сделать это минимум за сутки до прилёта."
          }
        },
        "finalTitle": "Летите в Ереван?",
        "finalText": "Пришлите номер рейса в Telegram — встретим и довезём до двери."
      }
    },
    "pay": {
      "cardCta": "Оплатить картой",
      "redirecting": "Открываем оплату…",
      "orTelegram": "или оформить в Telegram",
      "approx": "≈ {{amd}} · ≈ {{rub}}, оплата в евро, автопродление",
      "error": "Не получилось открыть оплату. Попробуйте ещё раз или оформите подписку в Telegram.",
      "metaTitle": "Оплата подписки — Barev Club",
      "checking": "Проверяем оплату…",
      "pendingTitle": "Ждём подтверждение оплаты",
      "pendingText": "Обычно это несколько секунд — страница обновится сама.",
      "backToPayment": "Вернуться к оплате",
      "paidTitle": "Оплата прошла! {{plan}} ждёт активации",
      "paidText": "Клуб работает в Telegram. Нажмите кнопку — бот привяжет подписку к вашему аккаунту, и скидки заработают сразу.",
      "activate": "Активировать в Telegram",
      "renewNote": "Подписка продлевается каждый месяц за {{price}}. Отключить продление можно в приложении, раздел «Членство».",
      "claimedTitle": "{{plan}} активирована",
      "claimedText": "Подписка привязана к вашему Telegram. Откройте бота — скидки уже действуют.",
      "openBot": "Открыть бота",
      "failedTitle": "Оплата не прошла",
      "failedText": "Деньги не списаны. Попробуйте ещё раз или другой картой.",
      "retry": "Попробовать ещё раз",
      "refundedTitle": "Платёж возвращён",
      "notFoundTitle": "Оплата не найдена",
      "notFoundText": "Проверьте ссылку или напишите нам — поможем."
    }
  },
  "privacy": {
    "title": "Политика конфиденциальности",
    "updated": "Редакция от 22 октября 2026 года",
    "intro": "Здесь написано, какие персональные данные собирает Barev Club, зачем, кому их передаёт и как вы можете ими управлять. Политика действует для сайта barevclub.com, Telegram-ботов и мини-приложений Barev Club.",
    "operator": {
      "title": "Кто обрабатывает данные",
      "body": "Оператор персональных данных — индивидуальный предприниматель Забудько Юрий Константинович (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), Республика Армения, ՀՎՀՀ {{tin}}. Barev Club — название сервиса.\nПо вопросам данных пишите на {{email}}, звоните по номеру {{phone}} или пишите в чат бота."
    },
    "data": {
      "title": "Какие данные мы получаем",
      "body": "• Из Telegram: ID, имя пользователя, имя и фамилию из профиля, язык. Номер телефона — только если вы сами им поделились.\n• Заявки с сайта: имя, телефон или ник в Telegram, ответы в подборе переезда (сроки, нужные услуги, бюджет). Для уборки — адрес, район, желаемое время и комментарий.\n• Заказы: адрес и район, точку на карте (если вы её указали), параметры услуги, дату и время, цену, скидку, статус оплаты, комментарии.\n• Документы: сканы паспорта и других документов, которые вы загружаете для услуг направления «Документы».\n• Переписку с исполнителем через бота, фотоотчёты, оценки и отзывы.\n• Членство: уровень (Barev, Barev+, Elite), сроки подписки, код клубной карты и отметки о её использовании у партнёров.\n• Источник: агентство или промокод, по которому вы пришли, и метки рекламных кампаний (UTM).\n• Технические данные: cookie с языком сайта, код агентства в памяти браузера и журналы сервера (IP-адрес, время и адрес запроса) для защиты от сбоев и атак.\nДанные банковских карт мы не получаем: при онлайн-оплате их вводят на странице платёжного сервиса Tribute (tribute.tg)."
    },
    "purposes": {
      "title": "Зачем мы их используем",
      "body": "• Оформить и выполнить заказ: подобрать исполнителя, рассчитать цену, сообщать о статусах.\n• Связаться с вами по заявке и подготовить план переезда.\n• Вести подписку, клубную карту и скидки.\n• Рассчитать вознаграждение агентству, которое вас привело, и выплаты исполнителям.\n• Вести бухгалтерский и налоговый учёт.\n• Улучшать сервис по оценкам и отзывам.\n• Присылать новости и предложения клуба, если вы от них не отказались."
    },
    "basis": {
      "title": "На каком основании",
      "body": "Мы обрабатываем данные на основании вашего согласия, которое вы даёте в боте или в форме на сайте, а также чтобы выполнить ваш заказ и требования законодательства Республики Армения, включая Закон «О защите персональных данных».\nСогласие можно отозвать в любой момент. Это не влияет на обработку, которая была до отзыва."
    },
    "recipients": {
      "title": "Кому мы передаём данные",
      "body": "Мы не продаём персональные данные и передаём только то, что нужно для конкретной задачи:\n• Исполнителю вашего заказа, а если заказ выполняет компания-партнёр, то и её диспетчеру: имя, язык, адрес и детали заказа. Ваш номер телефона исполнителю не показывается, общение идёт через бота.\n• Агентству недвижимости, которое вас привело: имя, пользуетесь ли вы клубом и суммы оплаченных заказов — для расчёта вознаграждения агентства.\n• Партнёру клуба, когда вы показываете клубную карту: имя и уровень членства.\n• Telegram: через него работают боты и мини-приложения. Telegram обрабатывает данные по своей политике.\n• Hostinger International: на его серверах хранятся база данных и файлы.\n• Платёжному сервису Tribute (tribute.tg), который принимает онлайн-платежи: email (если вы его указали), сумму, назначение платежа и внутренний номер клиента. Tribute обрабатывает данные карты на своей стороне по своей политике конфиденциальности.\n• Государственным органам: когда вы заказываете услугу по документам и мы подаём их от вашего имени, или когда этого требует закон."
    },
    "location": {
      "title": "Где хранятся данные",
      "body": "База данных и файлы хранятся на сервере в Германии (Франкфурт-на-Майне, провайдер Hostinger). Германия входит в Европейский союз, где действует общий регламент о защите данных (GDPR).\nДавая согласие, вы соглашаетесь на передачу данных за пределы Армении. Telegram может обрабатывать данные в других странах."
    },
    "retention": {
      "title": "Сколько мы храним данные",
      "body": "• Профиль — пока вы пользуетесь сервисом или до вашего запроса на удаление.\n• Заказы и платежи — 5 лет после завершения заказа: этого требуют бухгалтерский и налоговый учёт.\n• Переписку с исполнителем и фотоотчёты — 1 год после завершения заказа.\n• Заявки с сайта, по которым не было заказа, — 12 месяцев.\n• Сканы документов — 90 дней после завершения заказа, затем они удаляются автоматически.\nКогда срок истекает, данные удаляются или обезличиваются."
    },
    "security": {
      "title": "Как мы защищаем данные",
      "body": "• Сайт и приложения работают только по HTTPS.\n• Сканы документов хранятся в зашифрованном хранилище. Доступ к ним есть только у оператора и назначенного исполнителя, по временным ссылкам, и каждый просмотр записывается в журнал.\n• Вход в админку защищён паролем и двухфакторной аутентификацией, действия администраторов записываются в журнал.\n• Базу данных мы копируем каждый день."
    },
    "rights": {
      "title": "Ваши права",
      "body": "Вы можете:\n• узнать, какие данные о вас у нас есть, и получить их копию;\n• исправить неточные данные;\n• удалить данные и профиль, кроме тех, что мы обязаны хранить по закону;\n• отозвать согласие на обработку;\n• отказаться от новостей и предложений;\n• подать жалобу в Агентство по защите персональных данных Министерства юстиции Республики Армения.\nНапишите на {{email}} или в чат бота. Мы ответим в сроки, установленные законодательством Республики Армения. Без согласия на обработку мы не сможем принимать новые заказы."
    },
    "marketing": {
      "title": "Новости и предложения",
      "body": "Иногда мы присылаем в боте новости клуба, акции и предложения партнёров. Отказаться можно в любой момент: напишите «отписаться» в чат бота или на {{email}}.\nСообщения о заказах, подписке и напоминания о записи приходят независимо от этого."
    },
    "cookies": {
      "title": "Cookie",
      "body": "Сайт ставит одну cookie — barev_lang с выбранным языком, чтобы в следующий раз открыться на нём. Если вы пришли по ссылке агентства, его код сохраняется в памяти браузера, чтобы скидка не потерялась. Рекламных и аналитических cookie сайт не использует."
    },
    "age": {
      "title": "Возраст",
      "body": "Сервис предназначен для совершеннолетних. Если вам меньше 18 лет, не передавайте нам свои данные. Данные детей, например для документов семьи, передаёт родитель или законный представитель и отвечает за это."
    },
    "changes": {
      "title": "Изменения политики",
      "body": "Мы можем обновлять политику. Действующая редакция всегда на этой странице, дата редакции указана в начале. О существенных изменениях сообщим в боте.\nОсновной текст — на русском языке, переводы сделаны для удобства."
    }
  },
  "pricing": {
    "title": "Цены",
    "updated": "Действуют с 22 октября 2026 года",
    "intro": "Сколько стоят подписка Barev Club и услуги клуба. Заказывать услуги можно и без подписки, она только даёт скидки и консьержа. Все цены — в армянских драмах (֏).",
    "from": "от {{price}}",
    "perDay": "{{price}} за сутки",
    "plansTitle": "Подписка клуба",
    "plansNote": "Подписка оплачивается помесячно и продлевается, пока вы её не отмените. Отменить можно в любой момент — она будет действовать до конца оплаченного месяца.",
    "planNote": {
      "free": "Регистрация в Telegram-боте, без оплаты и без срока.",
      "plus": "Оформляется в боте. Если вы пришли от риэлторского агентства-партнёра — подписка в подарок (обычно {{days}} дней или больше, условия у каждого агентства свои).",
      "elite": "Оформляется через оператора клуба в чате бота."
    },
    "servicesTitle": "Услуги",
    "servicesNote": "Здесь — базовые цены. Точную стоимость заказа с учётом параметров и скидки по подписке бот показывает до того, как вы подтвердите заказ. Подтверждённая цена после этого не меняется.",
    "rows": {
      "cleaning": {
        "name": "Уборка квартиры",
        "note": "Зависит от вида уборки и числа комнат"
      },
      "transferStandard": {
        "name": "Трансфер из аэропорта «Звартноц», Стандарт",
        "note": "До 3 пассажиров, встреча с табличкой, 60 минут ожидания"
      },
      "transferPremium": {
        "name": "Трансфер из аэропорта «Звартноц», Премиум",
        "note": "Бизнес-класс, вода, SIM-карта"
      },
      "hotel": {
        "name": "Отель на первые дни",
        "note": "Цена с подпиской Barev+; без подписки — от {{base}} за сутки"
      },
      "socialCard": {
        "name": "Соцкарта под ключ",
        "note": "Перевод паспорта, нотариус, запись, сопровождение"
      },
      "consultation": {
        "name": "Консультация по ВНЖ",
        "note": "Засчитывается в стоимость сопровождения"
      },
      "residence": {
        "name": "Сопровождение ВНЖ",
        "note": "Основание, документы, подача, визит. Госпошлина {{fee}} за ВНЖ на 1 год платится государству отдельно"
      }
    },
    "payTitle": "Оплата и отмена",
    "payBody": "Подписки Barev+ и Elite оплачиваются онлайн картой в евро на сайте или в приложении и продлеваются автоматически каждый месяц — отключить продление можно в любой момент. Платежи принимает сервис Tribute; платёж за подписку возвращается по запросу в течение 14 дней. Заказы услуг можно оплатить онлайн в приложении (в евро по курсу) или наличными и переводом. Бесплатно отменить или перенести заказ можно не позднее чем за 24 часа до начала услуги. Подробности — в условиях использования и правилах возврата."
  },
  "terms": {
    "title": "Условия использования",
    "updated": "Редакция от 22 октября 2026 года",
    "intro": "Это условия, на которых Barev Club оказывает услуги через сайт barevclub.com, Telegram-ботов и мини-приложения. Оформляя заказ или подписку, вы принимаете эти условия.",
    "about": {
      "title": "Кто мы и что делаем",
      "body": "Barev Club — сервис для тех, кто переезжает в Армению или уже живёт здесь: бытовые услуги (уборка, трансфер из аэропорта, отель на первые дни), помощь с документами (соцкарта, вид на жительство), обучение и скидки у партнёров клуба.\nУслуги оказывает индивидуальный предприниматель Забудько Юрий Константинович (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), Республика Армения, ՀՎՀՀ {{tin}}. Контакты: {{email}}, {{phone}}.\nЗаказы выполняют проверенные исполнители — наши сотрудники или компании-партнёры. Перед вами за результат отвечает Barev Club."
    },
    "acceptance": {
      "title": "Принятие условий",
      "body": "Условия действуют с момента, когда вы оформили заказ, подписку или заявку на сайте или в боте. Пользоваться сервисом можно с 18 лет.\nЕсли вы не согласны с условиями, не оформляйте заказ."
    },
    "orders": {
      "title": "Как оформляется заказ",
      "body": "• Вы выбираете услугу в боте или оставляете заявку на сайте и указываете параметры: адрес, дату, время и другое.\n• До подтверждения бот показывает итоговую цену, скидку и условия отмены.\n• Заказ считается принятым, когда вы его подтвердили, а мы назначили исполнителя. Об этом и о каждом следующем статусе приходит уведомление.\n• Общение с исполнителем идёт через чат в боте.\nЕсли выполнить заказ в выбранное время не получается, мы предложим другое время или отменим заказ без удержания."
    },
    "prices": {
      "title": "Цены",
      "body": "Цены указаны в армянских драмах на странице «Цены» и в боте. Мы можем менять цены, но цена уже подтверждённого заказа не меняется.\nГосударственные пошлины и сборы, например пошлина за вид на жительство, в цену услуги не входят, если это не написано прямо. Их размер мы называем заранее."
    },
    "payment": {
      "title": "Оплата",
      "body": "Подписки Barev+ и Barev Elite можно оплатить онлайн картой на сайте или в приложении. Подписка продлевается автоматически каждый месяц с той же карты; отключить продление можно в любой момент в приложении (раздел «Членство») или написав нам — оплаченный месяц при этом сохраняется. Заказы услуг можно оплатить онлайн в приложении — сумма пересчитывается из драмов в евро по курсу, указанному перед оплатой. Онлайн-платежи принимает платёжный сервис Tribute (tribute.tg); данные карты вводятся на его странице, мы их не получаем и не храним.\nУслуги (уборка, трансфер, документы и другие) онлайн не продаются: их оплачивают наличными или переводом исполнителю или переводом на счёт Barev Club — способ выбирается в заказе.\nПо запросу мы выдаём документ об оплате."
    },
    "cancel": {
      "title": "Отмена и перенос",
      "body": "Бесплатно отменить или перенести заказ можно не позднее чем за 24 часа до начала услуги — в боте или в чате с оператором.\nПри более поздней отмене удерживается часть стоимости. Её размер указан в карточке услуги до подтверждения заказа, по умолчанию — 30%.\nЕсли заказ отменяем мы или исполнитель не приехал, деньги возвращаются полностью. Подробнее — в правилах отмены и возврата."
    },
    "subscription": {
      "title": "Подписка Barev+ и Barev Elite",
      "body": "• Подписка даёт скидки на услуги клуба, подарки партнёров и консьержа в чате. Состав и цены уровней — на странице «Цены».\n• Подписка оплачивается помесячно и продлевается автоматически, пока вы её не отмените. О продлении мы напоминаем за 3 дня.\n• Скидка применяется к заказам, оформленным, пока подписка действует.\n• Подарочный период по коду агентства-партнёра даётся один раз на одного клиента.\n• Отменить подписку можно в любой момент в боте или в чате с оператором. Она будет действовать до конца оплаченного периода."
    },
    "perks": {
      "title": "Скидки и подарки партнёров",
      "body": "Скидки и подарки по клубной карте предоставляют партнёры клуба — кафе, рестораны и другие компании. Условия каждого предложения указаны в каталоге партнёров.\nЗа товары и услуги партнёров отвечает партнёр. Предложения партнёров могут меняться и заканчиваться."
    },
    "docs": {
      "title": "Услуги по документам",
      "body": "Мы помогаем собрать документы, переводим их, записываем и сопровождаем вас в государственных органах. Решение о выдаче документа или вида на жительство принимает государственный орган, и гарантировать его мы не можем.\nВы отвечаете за то, что документы и сведения, которые вы нам передаёте, подлинные и точные. Если отказ связан с нашей ошибкой, мы исправим её за свой счёт."
    },
    "client": {
      "title": "Ваши обязанности",
      "body": "• Указывать верные данные: адрес, контакты, параметры заказа.\n• Обеспечить доступ к квартире в назначенное время и безопасные условия для работы исполнителя.\n• Уважительно общаться с исполнителями и операторами.\n• Не использовать сервис для незаконных целей.\nЕсли исполнитель не смог начать работу по вашей вине (например, никого нет по адресу), это считается поздней отменой."
    },
    "quality": {
      "title": "Качество и претензии",
      "body": "Если результат вас не устроил, напишите в чат заказа в течение 24 часов после выполнения и, если можно, приложите фото. Мы бесплатно исправим недочёты или вернём часть или всю стоимость.\nЕсли исполнитель повредил ваше имущество, сообщите об этом в течение 24 часов — мы разберёмся и возместим подтверждённый ущерб."
    },
    "liability": {
      "title": "Ответственность",
      "body": "Наша ответственность по заказу ограничена его стоимостью, кроме случаев подтверждённого ущерба имуществу и случаев, когда закон не допускает такого ограничения.\nМы не отвечаем за задержки и отмены из-за обстоятельств, на которые не можем повлиять: решений государственных органов, задержек рейсов, стихийных бедствий, сбоев Telegram."
    },
    "content": {
      "title": "Материалы сайта",
      "body": "Тексты, дизайн, логотип и название Barev Club принадлежат владельцу сервиса. Копировать их без разрешения нельзя."
    },
    "changes": {
      "title": "Изменения условий",
      "body": "Мы можем обновлять условия. Действующая редакция всегда на этой странице, дата редакции указана в начале. Уже подтверждённые заказы выполняются на прежних условиях. О существенных изменениях подписки мы сообщим в боте заранее."
    },
    "law": {
      "title": "Применимое право и споры",
      "body": "К условиям применяется законодательство Республики Армения. Споры мы сначала решаем переговорами — напишите на {{email}}, мы ответим в течение 3 рабочих дней. Если договориться не удалось, спор рассматривает суд Республики Армения.\nВаши права потребителя по закону эти условия не ограничивают.\nОсновной текст — на русском языке, переводы сделаны для удобства."
    }
  },
  "refund": {
    "title": "Отмена и возврат",
    "updated": "Редакция от 22 октября 2026 года",
    "intro": "Когда и сколько денег Barev Club возвращает за услуги и подписку и как подать запрос на возврат.",
    "cancelClient": {
      "title": "Если отменяете вы",
      "body": "• За 24 часа до начала услуги и раньше — отмена и перенос бесплатны, оплата возвращается полностью.\n• Меньше чем за 24 часа — удерживается часть стоимости, остальное возвращается. Размер удержания указан в карточке услуги до подтверждения заказа, по умолчанию — 30%.\n• После начала услуги стоимость уже выполненной части не возвращается."
    },
    "cancelUs": {
      "title": "Если отменяем мы",
      "body": "Если мы отменили заказ, не нашли исполнителя или исполнитель не приехал, вы выбираете: перенос на удобное время или полный возврат денег."
    },
    "quality": {
      "title": "Если результат не устроил",
      "body": "Напишите в чат заказа в течение 24 часов после выполнения и, если можно, приложите фото. Мы бесплатно исправим недочёты, а если это невозможно — вернём часть или всю стоимость, в зависимости от того, что было не так."
    },
    "subscription": {
      "title": "Подписка Barev+ и Barev Elite",
      "body": "• Любой платёж за подписку можно вернуть полностью, если попросить об этом в течение 14 дней после списания.\n• Отменить подписку можно в любой момент — тогда следующий платёж не спишется, а подписка будет действовать до конца оплаченного месяца.\n• Подарочный период бесплатный, возвращать за него нечего."
    },
    "nonRefundable": {
      "title": "Что не возвращается",
      "body": "• Государственные пошлины и сборы, которые мы уже заплатили от вашего имени.\n• Расходы, которые мы уже понесли по вашему заказу у третьих лиц: например, нотариальный перевод или бронь отеля по правилам отеля.\n• Товары и услуги партнёров клуба — по ним действуют правила партнёра."
    },
    "howTo": {
      "title": "Как запросить возврат",
      "body": "Напишите в чат бота или на {{email}} и укажите номер заказа или подписки и причину. Мы ответим в течение 3 рабочих дней.\nЕсли вы оплатили онлайн, деньги вернутся на ту же карту через платёжный сервис Tribute — обычно в течение нескольких рабочих дней после нашего подтверждения."
    },
    "timing": {
      "title": "Сроки и способ возврата",
      "body": "Деньги возвращаются тем же способом, которым вы платили, в течение 10 рабочих дней после одобрения возврата. Возврат на карту может идти ещё несколько дней — это зависит от банка. Если вы платили наличными, вернём переводом или наличными, как вам удобнее.\nПо вопросам возврата: {{email}}, {{phone}}."
    }
  }
}
